<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content">
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hand-peace-variant"></i> mdi
              mdi-hand-peace-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hand-pointing-down"></i> mdi
              mdi-hand-pointing-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hand-pointing-left"></i> mdi
              mdi-hand-pointing-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hand-pointing-right"></i> mdi
              mdi-hand-pointing-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hand-pointing-up"></i> mdi
              mdi-hand-pointing-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hanger"></i> mdi mdi-hanger
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hard-hat"></i> mdi mdi-hard-hat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-harddisk"></i> mdi mdi-harddisk
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-headphones"></i> mdi mdi-headphones
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-headphones-bluetooth"></i> mdi
              mdi-headphones-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-headphones-box"></i> mdi
              mdi-headphones-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-headphones-off"></i> mdi
              mdi-headphones-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-headphones-settings"></i> mdi
              mdi-headphones-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-headset"></i> mdi mdi-headset
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-headset-dock"></i> mdi mdi-headset-dock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-headset-off"></i> mdi mdi-headset-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart"></i> mdi mdi-heart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-box"></i> mdi mdi-heart-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-box-outline"></i> mdi
              mdi-heart-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-broken"></i> mdi mdi-heart-broken
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-circle"></i> mdi mdi-heart-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-circle-outline"></i> mdi
              mdi-heart-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-half"></i> mdi mdi-heart-half
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-half-full"></i> mdi
              mdi-heart-half-full
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-half-outline"></i> mdi
              mdi-heart-half-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-multiple"></i> mdi
              mdi-heart-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-multiple-outline"></i> mdi
              mdi-heart-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-off"></i> mdi mdi-heart-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-outline"></i> mdi
              mdi-heart-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-pulse"></i> mdi mdi-heart-pulse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-helicopter"></i> mdi mdi-helicopter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-help"></i> mdi mdi-help
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-help-box"></i> mdi mdi-help-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-help-circle"></i> mdi mdi-help-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-help-circle-outline"></i> mdi
              mdi-help-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-help-network"></i> mdi mdi-help-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon"></i> mdi mdi-hexagon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon-multiple"></i> mdi
              mdi-hexagon-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon-outline"></i> mdi
              mdi-hexagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon-slice-1"></i> mdi
              mdi-hexagon-slice-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon-slice-2"></i> mdi
              mdi-hexagon-slice-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon-slice-3"></i> mdi
              mdi-hexagon-slice-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon-slice-4"></i> mdi
              mdi-hexagon-slice-4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon-slice-5"></i> mdi
              mdi-hexagon-slice-5
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagon-slice-6"></i> mdi
              mdi-hexagon-slice-6
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagram"></i> mdi mdi-hexagram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hexagram-outline"></i> mdi
              mdi-hexagram-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-high-definition"></i> mdi
              mdi-high-definition
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-high-definition-box"></i> mdi
              mdi-high-definition-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-highway"></i> mdi mdi-highway
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hinduism"></i> mdi mdi-hinduism
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-history"></i> mdi mdi-history
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hockey-puck"></i> mdi mdi-hockey-puck
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-check"></i> mdi mdi-eye-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-check-outline"></i> mdi
              mdi-eye-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi mdi-format-list-numbered-rtl"></i> mdi
              mdi-format-list-numbered-rtl
            </div>

            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-list-numbered-rtl"></i> mdi
              mdi-format-list-numbered-rtl
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tortoise"></i> mdi mdi-tortoise
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bread-slice"></i> mdi mdi-bread-slice
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bread-slice-outline"></i> mdi
              mdi-bread-slice-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fountain-pen"></i> mdi mdi-fountain-pen
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fountain-pen-tip"></i> mdi
              mdi-fountain-pen-tip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-circle"></i> mdi
              mdi-arrow-up-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-circle-outline"></i> mdi
              mdi-arrow-up-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-circle"></i> mdi
              mdi-arrow-right-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-circle-outline"></i> mdi
              mdi-arrow-right-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-circle"></i> mdi
              mdi-arrow-down-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-circle-outline"></i> mdi
              mdi-arrow-down-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-circle"></i> mdi
              mdi-arrow-left-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-circle-outline"></i> mdi
              mdi-arrow-left-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-quora"></i> mdi mdi-quora
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-text-wrapping-clip"></i> mdi
              mdi-format-text-wrapping-clip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-text-wrapping-overflow"></i> mdi
              mdi-format-text-wrapping-overflow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-text-wrapping-wrap"></i> mdi
              mdi-format-text-wrapping-wrap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-textbox"></i> mdi
              mdi-format-textbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-merge-cells"></i> mdi
              mdi-table-merge-cells
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-heart-broken-outline"></i> mdi
              mdi-heart-broken-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dishwasher"></i> mdi mdi-dishwasher
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-r-box-outline"></i> mdi
              mdi-alpha-r-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-artist-outline"></i> mdi
              mdi-artist-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-artist"></i> mdi mdi-artist
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flower-poppy"></i> mdi mdi-flower-poppy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flickr"></i> mdi mdi-flickr
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fedora"></i> mdi mdi-fedora
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-sync"></i> mdi mdi-folder-sync
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-sync-outline"></i> mdi
              mdi-folder-sync-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tank"></i> mdi mdi-tank
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bullet"></i> mdi mdi-bullet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ammunition"></i> mdi mdi-ammunition
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-safety-goggles"></i> mdi
              mdi-safety-goggles
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-account"></i> mdi
              mdi-briefcase-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-account-outline"></i> mdi
              mdi-briefcase-account-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transit-connection"></i> mdi
              mdi-transit-connection
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transit-connection-variant"></i> mdi
              mdi-transit-connection-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stamper"></i> mdi mdi-stamper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sack"></i> mdi mdi-sack
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sack-percent"></i> mdi mdi-sack-percent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blood-bag"></i> mdi mdi-blood-bag
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-clock"></i> mdi mdi-map-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-clock-outline"></i> mdi
              mdi-map-clock-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-box"></i> mdi mdi-email-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link-box-variant"></i> mdi
              mdi-link-box-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link-box"></i> mdi mdi-link-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link-box-variant-outline"></i> mdi
              mdi-link-box-variant-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link-box-outline"></i> mdi
              mdi-link-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-podium"></i> mdi mdi-podium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-podium-bronze"></i> mdi
              mdi-podium-bronze
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-podium-gold"></i> mdi mdi-podium-gold
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-podium-silver"></i> mdi
              mdi-podium-silver
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weight-gram"></i> mdi mdi-weight-gram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drama-masks"></i> mdi mdi-drama-masks
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skew-less"></i> mdi mdi-skew-less
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skew-more"></i> mdi mdi-skew-more
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-perspective-less"></i> mdi
              mdi-perspective-less
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-perspective-more"></i> mdi
              mdi-perspective-more
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-select-color"></i> mdi mdi-select-color
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-selection-ellipse"></i> mdi
              mdi-selection-ellipse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-speaker-multiple"></i> mdi
              mdi-speaker-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hubspot"></i> mdi mdi-hubspot
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-library-movie"></i> mdi
              mdi-library-movie
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-library-video"></i> mdi
              mdi-library-video
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-youtube-subscription"></i> mdi
              mdi-youtube-subscription
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-refresh"></i> mdi
              mdi-database-refresh
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-settings"></i> mdi
              mdi-database-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-remove"></i> mdi
              mdi-database-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-percent"></i> mdi
              mdi-brightness-percent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zigbee"></i> mdi mdi-zigbee
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-city"></i> mdi mdi-home-city
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-city-outline"></i> mdi
              mdi-home-city-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cursor-default-click"></i> mdi
              mdi-cursor-default-click
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cursor-default-click-outline"></i> mdi
              mdi-cursor-default-click-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fast-forward-30"></i> mdi
              mdi-fast-forward-30
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rewind-10"></i> mdi mdi-rewind-10
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-link-variant"></i> mdi
              mdi-shield-link-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-link-variant-outline"></i> mdi
              mdi-shield-link-variant-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cash-register"></i> mdi
              mdi-cash-register
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-outlook"></i> mdi mdi-outlook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ruby"></i> mdi mdi-ruby
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-arrow-left-outline"></i> mdi
              mdi-clipboard-arrow-left-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-arrow-right-outline"></i> mdi
              mdi-clipboard-arrow-right-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-arrow-right"></i> mdi
              mdi-clipboard-arrow-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-alert-outline"></i> mdi
              mdi-clipboard-alert-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skate"></i> mdi mdi-skate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-roller-skate"></i> mdi mdi-roller-skate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rollerblade"></i> mdi mdi-rollerblade
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transmission-tower"></i> mdi
              mdi-transmission-tower
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mother-nurse"></i> mdi mdi-mother-nurse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-decagram-outline"></i> mdi
              mdi-alert-decagram-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-box-outline"></i> mdi
              mdi-alert-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-octagon-outline"></i> mdi
              mdi-alert-octagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-octagram-outline"></i> mdi
              mdi-alert-octagram-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-pound"></i> mdi mdi-folder-pound
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-pound-outline"></i> mdi
              mdi-folder-pound-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-christianity-outline"></i> mdi
              mdi-christianity-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-celtic-cross"></i> mdi mdi-celtic-cross
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bolnisi-cross"></i> mdi
              mdi-bolnisi-cross
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-path"></i> mdi
              mdi-map-marker-path
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-save-edit"></i> mdi
              mdi-content-save-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-save-edit-outline"></i> mdi
              mdi-content-save-edit-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-go-kart"></i> mdi mdi-go-kart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-go-kart-track"></i> mdi
              mdi-go-kart-track
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flare"></i> mdi mdi-flare
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-grain"></i> mdi mdi-grain
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-tap-hold"></i> mdi
              mdi-gesture-tap-hold
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hdr"></i> mdi mdi-hdr
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hdr-off"></i> mdi mdi-hdr-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trophy-broken"></i> mdi
              mdi-trophy-broken
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-goodreads"></i> mdi mdi-goodreads
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-brake-alert"></i> mdi
              mdi-car-brake-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wiper-wash"></i> mdi mdi-wiper-wash
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-brake-hold"></i> mdi
              mdi-car-brake-hold
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-traction-control"></i> mdi
              mdi-car-traction-control
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-parking-lights"></i> mdi
              mdi-car-parking-lights
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-defrost-front"></i> mdi
              mdi-car-defrost-front
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-defrost-rear"></i> mdi
              mdi-car-defrost-rear
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-cruise-control"></i> mdi
              mdi-car-cruise-control
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contactless-payment"></i> mdi
              mdi-contactless-payment
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-credit-card-wireless"></i> mdi
              mdi-credit-card-wireless
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rewind-30"></i> mdi mdi-rewind-30
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fast-forward-10"></i> mdi
              mdi-fast-forward-10
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-racquetball"></i> mdi mdi-racquetball
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tea"></i> mdi mdi-tea
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tea-outline"></i> mdi mdi-tea-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-forwardburger"></i> mdi
              mdi-forwardburger
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-restart-off"></i> mdi mdi-restart-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis"></i> mdi mdi-axis
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-arrow"></i> mdi mdi-axis-arrow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-x-arrow"></i> mdi mdi-axis-x-arrow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-y-arrow"></i> mdi mdi-axis-y-arrow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-z-arrow"></i> mdi mdi-axis-z-arrow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-z-arrow-lock"></i> mdi
              mdi-axis-z-arrow-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-lock"></i> mdi mdi-axis-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-arrow-lock"></i> mdi
              mdi-axis-arrow-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-x-y-arrow-lock"></i> mdi
              mdi-axis-x-y-arrow-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-x-arrow-lock"></i> mdi
              mdi-axis-x-arrow-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-y-arrow-lock"></i> mdi
              mdi-axis-y-arrow-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rotate-orbit"></i> mdi mdi-rotate-orbit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-z-rotate-counterclockwise"></i> mdi
              mdi-axis-z-rotate-counterclockwise
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-z-rotate-clockwise"></i> mdi
              mdi-axis-z-rotate-clockwise
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-room-service-outline"></i> mdi
              mdi-room-service-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-x-rotate-clockwise"></i> mdi
              mdi-axis-x-rotate-clockwise
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-x-rotate-counterclockwise"></i> mdi
              mdi-axis-x-rotate-counterclockwise
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-y-rotate-clockwise"></i> mdi
              mdi-axis-y-rotate-clockwise
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axis-y-rotate-counterclockwise"></i> mdi
              mdi-axis-y-rotate-counterclockwise
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-face-agent"></i> mdi mdi-face-agent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mailbox-open"></i> mdi mdi-mailbox-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mailbox-open-outline"></i> mdi
              mdi-mailbox-open-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mailbox-open-up"></i> mdi
              mdi-mailbox-open-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mailbox-outline"></i> mdi
              mdi-mailbox-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mailbox-up-outline"></i> mdi
              mdi-mailbox-up-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mailbox-open-up-outline"></i> mdi
              mdi-mailbox-open-up-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mailbox-up"></i> mdi mdi-mailbox-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-outline"></i> mdi
              mdi-camera-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-classroom"></i> mdi
              mdi-google-classroom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-android-messages"></i> mdi
              mdi-android-messages
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-minus"></i> mdi
              mdi-calendar-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart-arrow-down"></i> mdi
              mdi-cart-arrow-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart-arrow-up"></i> mdi
              mdi-cart-arrow-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart-minus"></i> mdi mdi-cart-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart-remove"></i> mdi mdi-cart-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-solar-panel"></i> mdi mdi-solar-panel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-solar-panel-large"></i> mdi
              mdi-solar-panel-large
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-air-filter"></i> mdi mdi-air-filter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-motion-sensor"></i> mdi
              mdi-motion-sensor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-air-purifier"></i> mdi mdi-air-purifier
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wind-turbine"></i> mdi mdi-wind-turbine
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-creative-commons"></i> mdi
              mdi-creative-commons
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-adchoices"></i> mdi mdi-adchoices
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apps-box"></i> mdi mdi-apps-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transfer-right"></i> mdi
              mdi-transfertennis-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transfer-down"></i> mdi
              mdi-transfer-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transfer-left"></i> mdi
              mdi-transfer-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transfer-up"></i> mdi mdi-transfer-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-atm"></i> mdi mdi-atm
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-point-of-sale"></i> mdi
              mdi-point-of-sale
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-racing-helmet"></i> mdi
              mdi-racing-helmet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gif"></i> mdi mdi-gif
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hiking"></i> mdi mdi-hiking
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-carry-on-bag-check"></i> mdi
              mdi-carry-on-bag-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-search"></i> mdi
              mdi-shield-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-subway-alert-variant"></i> mdi
              mdi-subway-alert-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rugby"></i> mdi mdi-rugby
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mixed-martial-arts"></i> mdi
              mdi-mixed-martial-arts
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cricket"></i> mdi mdi-cricket
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-monitor-off"></i> mdi mdi-monitor-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-kabaddi"></i> mdi mdi-kabaddi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-domain-off"></i> mdi mdi-domain-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-alert"></i> mdi mdi-bell-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-circle"></i> mdi mdi-bell-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-circle-outline"></i> mdi
              mdi-bell-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dev-to"></i> mdi mdi-dev-to
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-text-rotation-none"></i> mdi
              mdi-format-text-rotation-none
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-text-rotation-down"></i> mdi
              mdi-format-text-rotation-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-swipe"></i> mdi
              mdi-gesture-swipe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-1"></i> mdi mdi-home-floor-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-2"></i> mdi mdi-home-floor-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-a"></i> mdi mdi-home-floor-a
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-b"></i> mdi mdi-home-floor-b
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-a"></i> mdi mdi-home-floor-a
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-b"></i> mdi mdi-home-floor-b
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-g"></i> mdi mdi-home-floor-g
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-l"></i> mdi mdi-home-floor-l
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-floor-3"></i> mdi mdi-home-floor-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-turtle"></i> mdi mdi-turtle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-face-recognition"></i> mdi
              mdi-face-recognition
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-postage-stamp"></i> mdi
              mdi-postage-stamp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-adwords"></i> mdi
              mdi-google-adwords
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-street-view"></i> mdi
              mdi-google-street-view
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sort-variant-lock-open"></i> mdi
              mdi-sort-variant-lock-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sort-variant-lock"></i> mdi
              mdi-sort-variant-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-devil"></i> mdi
              mdi-emoticon-devil
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-dead"></i> mdi
              mdi-emoticon-dead
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon"></i> mdi mdi-emoticon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-excited"></i> mdi
              mdi-emoticon-excited
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-cool"></i> mdi
              mdi-emoticon-cool
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-neutral"></i> mdi
              mdi-emoticon-neutral
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-poop-outline"></i> mdi
              mdi-emoticon-poop-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-sad"></i> mdi mdi-emoticon-sad
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-happy"></i> mdi
              mdi-emoticon-happy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-tongue"></i> mdi
              mdi-emoticon-tongue
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-tongue-outline"></i> mdi
              mdi-emoticon-tongue-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-cry-outline"></i> mdi
              mdi-emoticon-cry-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-cry"></i> mdi mdi-emoticon-cry
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-kiss-outline"></i> mdi
              mdi-emoticon-kiss-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-kiss"></i> mdi
              mdi-emoticon-kiss
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-wink-outline"></i> mdi
              mdi-emoticon-wink-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-wink"></i> mdi
              mdi-emoticon-wink
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-angry-outline"></i> mdi
              mdi-emoticon-angry-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-angry"></i> mdi
              mdi-emoticon-angry
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sheep"></i> mdi mdi-sheep
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-repository-multiple"></i> mdi
              mdi-source-repository-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-repository"></i> mdi
              mdi-source-repository
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart-arrow-right"></i> mdi
              mdi-cart-arrow-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radio-am"></i> mdi mdi-radio-am
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radio-fm"></i> mdi mdi-radio-fm
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dump-truck"></i> mdi mdi-dump-truck
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-airbag"></i> mdi mdi-airbag
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seatbelt"></i> mdi mdi-seatbelt
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-account-outline"></i> mdi
              mdi-clipboard-account-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-arrow-down-outline"></i> mdi
              mdi-clipboard-arrow-down-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-arrow-up-outline"></i> mdi
              mdi-clipboard-arrow-up-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-arrow-up"></i> mdi
              mdi-clipboard-arrow-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hazard-lights"></i> mdi
              mdi-hazard-lights
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-esp"></i> mdi mdi-car-esp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-brake-parking"></i> mdi
              mdi-car-brake-parking
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-brake-abs"></i> mdi
              mdi-car-brake-abs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-tire-alert"></i> mdi
              mdi-car-tire-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-search-outline"></i> mdi
              mdi-file-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-search"></i> mdi mdi-file-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-light-high"></i> mdi
              mdi-car-light-high
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-light-fog"></i> mdi
              mdi-car-light-fog
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-light-dimmed"></i> mdi
              mdi-car-light-dimmed
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-box-multiple-outline"></i> mdi
              mdi-close-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-box-multiple"></i> mdi
              mdi-close-box-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-cross-outline"></i> mdi
              mdi-shield-cross-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-cross"></i> mdi mdi-shield-cross
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link-off"></i> mdi mdi-link-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link"></i> mdi mdi-link
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-search-outline"></i> mdi
              mdi-briefcase-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-download-outline"></i> mdi
              mdi-briefcase-download-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-upload-outline"></i> mdi
              mdi-briefcase-upload-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-edit-outline"></i> mdi
              mdi-briefcase-edit-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-remove-outline"></i> mdi
              mdi-briefcase-remove-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-plus-outline"></i> mdi
              mdi-briefcase-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-minus-outline"></i> mdi
              mdi-briefcase-minus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link-plus"></i> mdi mdi-link-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-food-apple-outline"></i> mdi
              mdi-food-apple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-spa-outline"></i> mdi mdi-spa-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-spa"></i> mdi mdi-spa
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-size-select-small"></i> mdi
              mdi-image-size-select-small
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-size-select-large"></i> mdi
              mdi-image-size-select-large
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-size-select-actual"></i> mdi
              mdi-image-size-select-actual
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-plus-circle-outline"></i> mdi
              mdi-numeric-9-plus-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-plus-circle"></i> mdi
              mdi-numeric-9-plus-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-circle-outline"></i> mdi
              mdi-numeric-9-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-circle"></i> mdi
              mdi-numeric-9-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-8-circle-outline"></i> mdi
              mdi-numeric-8-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-8-circle"></i> mdi
              mdi-numeric-8-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-7-circle-outline"></i> mdi
              mdi-numeric-7-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-7-circle"></i> mdi
              mdi-numeric-7-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-6-circle-outline"></i> mdi
              mdi-numeric-6-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-6-circle"></i> mdi
              mdi-numeric-6-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-5-circle-outline"></i> mdi
              mdi-numeric-5-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-5-circle"></i> mdi
              mdi-numeric-5-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-4-circle-outline"></i> mdi
              mdi-numeric-4-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-4-circle"></i> mdi
              mdi-numeric-4-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-3-circle-outline"></i> mdi
              mdi-numeric-3-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-3-circle"></i> mdi
              mdi-numeric-3-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-2-circle-outline"></i> mdi
              mdi-numeric-2-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-2-circle"></i> mdi
              mdi-numeric-2-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-1-circle-outline"></i> mdi
              mdi-numeric-1-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-1-circle"></i> mdi
              mdi-numeric-1-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-0-circle-outline"></i> mdi
              mdi-numeric-0-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-0-circle"></i> mdi
              mdi-numeric-0-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-z-circle-outline"></i> mdi
              mdi-alpha-z-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-z-circle"></i> mdi
              mdi-alpha-z-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-z-box-outline"></i> mdi
              mdi-alpha-z-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-y-circle-outline"></i> mdi
              mdi-alpha-y-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-y-circle"></i> mdi
              mdi-alpha-y-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-y-box-outline"></i> mdi
              mdi-alpha-y-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-x-circle-outline"></i> mdi
              mdi-alpha-x-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-x-circle"></i> mdi
              mdi-alpha-x-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-x-box-outline"></i> mdi
              mdi-alpha-x-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-w-circle-outline"></i> mdi
              mdi-alpha-w-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-w-circle"></i> mdi
              mdi-alpha-w-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-w-box-outline"></i> mdi
              mdi-alpha-w-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-v-circle-outline"></i> mdi
              mdi-alpha-v-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-v-circle"></i> mdi
              mdi-alpha-v-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-v-box-outline"></i> mdi
              mdi-alpha-v-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-u-circle-outline"></i> mdi
              mdi-alpha-u-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-u-circle"></i> mdi
              mdi-alpha-u-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-u-box-outline"></i> mdi
              mdi-alpha-u-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-t-circle-outline"></i> mdi
              mdi-alpha-t-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-t-circle"></i> mdi
              mdi-alpha-t-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-t-box-outline"></i> mdi
              mdi-alpha-t-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-s-circle-outline"></i> mdi
              mdi-alpha-s-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-s-circle"></i> mdi
              mdi-alpha-s-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-s-box-outline"></i> mdi
              mdi-alpha-s-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-r-circle-outline"></i> mdi
              mdi-alpha-r-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-r-circle"></i> mdi
              mdi-alpha-r-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-r-box-outline"></i> mdi
              mdi-alpha-r-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-q-circle-outline"></i> mdi
              mdi-alpha-q-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-q-circle"></i> mdi
              mdi-alpha-q-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-q-box-outline"></i> mdi
              mdi-alpha-q-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-p-circle-outline"></i> mdi
              mdi-alpha-p-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-p-circle"></i> mdi
              mdi-alpha-p-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-p-box-outline"></i> mdi
              mdi-alpha-p-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-o-circle-outline"></i> mdi
              mdi-alpha-o-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-o-circle"></i> mdi
              mdi-alpha-o-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-o-box-outline"></i> mdi
              mdi-alpha-o-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-n-circle-outline"></i> mdi
              mdi-alpha-n-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-n-circle"></i> mdi
              mdi-alpha-n-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-n-box-outline"></i> mdi
              mdi-alpha-n-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-m-circle-outline"></i> mdi
              mdi-alpha-m-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-m-circle"></i> mdi
              mdi-alpha-m-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-m-box-outline"></i> mdi
              mdi-alpha-m-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-l-circle-outline"></i> mdi
              mdi-alpha-l-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-l-circle"></i> mdi
              mdi-alpha-l-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-l-box-outline"></i> mdi
              mdi-alpha-l-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-k-circle-outline"></i> mdi
              mdi-alpha-k-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-k-circle"></i> mdi
              mdi-alpha-k-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-k-box-outline"></i> mdi
              mdi-alpha-k-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-j-circle-outline"></i> mdi
              mdi-alpha-j-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-j-circle"></i> mdi
              mdi-alpha-j-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-j-box-outline"></i> mdi
              mdi-alpha-j-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-i-circle-outline"></i> mdi
              mdi-alpha-i-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-i-circle"></i> mdi
              mdi-alpha-i-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-i-box-outline"></i> mdi
              mdi-alpha-i-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-h-circle-outline"></i> mdi
              mdi-alpha-h-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-h-circle"></i> mdi
              mdi-alpha-h-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-h-box-outline"></i> mdi
              mdi-alpha-h-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-g-circle-outline"></i> mdi
              mdi-alpha-g-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-g-circle"></i> mdi
              mdi-alpha-g-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-g-box-outline"></i> mdi
              mdi-alpha-g-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-f-circle-outline"></i> mdi
              mdi-alpha-f-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-f-circle"></i> mdi
              mdi-alpha-f-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-f-box-outline"></i> mdi
              mdi-alpha-f-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-e-circle-outline"></i> mdi
              mdi-alpha-e-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-e-circle"></i> mdi
              mdi-alpha-e-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-e-box-outline"></i> mdi
              mdi-alpha-e-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-d-circle-outline"></i> mdi
              mdi-alpha-d-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-d-circle"></i> mdi
              mdi-alpha-d-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-d-box-outline"></i> mdi
              mdi-alpha-d-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-c-circle-outline"></i> mdi
              mdi-alpha-c-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-c-circle"></i> mdi
              mdi-alpha-c-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-c-box-outline"></i> mdi
              mdi-alpha-c-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-b-circle-outline"></i> mdi
              mdi-alpha-b-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-b-circle"></i> mdi
              mdi-alpha-b-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-b-box-outline"></i> mdi
              mdi-alpha-b-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-a-circle-outline"></i> mdi
              mdi-alpha-a-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-a-circle"></i> mdi
              mdi-alpha-a-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-a-box-outline"></i> mdi
              mdi-alpha-a-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-logout"></i> mdi mdi-logout
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-login"></i> mdi mdi-login
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-progress-wrench"></i> mdi
              mdi-progress-wrench
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-truck-check"></i> mdi mdi-truck-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-multiple-plus-outline"></i> mdi
              mdi-account-multiple-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-multiple-outline"></i> mdi
              mdi-account-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-box-outline"></i> mdi
              mdi-check-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-box-multiple-outline"></i> mdi
              mdi-check-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fuse-blade"></i> mdi mdi-fuse-blade
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fuse"></i> mdi mdi-fuse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm-light-outline"></i> mdi
              mdi-alarm-light-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pencil-outline"></i> mdi
              mdi-pencil-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-network-outline"></i> mdi
              mdi-check-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-off-outline"></i> mdi
              mdi-network-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-off"></i> mdi mdi-network-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-network"></i> mdi
              mdi-check-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-basketball-hoop-outline"></i> mdi
              mdi-basketball-hoop-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-basketball-hoop"></i> mdi
              mdi-basketball-hoop
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-network-outline"></i> mdi
              mdi-close-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-heart-outline"></i> mdi
              mdi-account-heart-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-key-outline"></i> mdi
              mdi-account-key-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-star-outline"></i> mdi
              mdi-account-star-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooltip-account"></i> mdi
              mdi-tooltip-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-server-network-off"></i> mdi
              mdi-server-network-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-server-network"></i> mdi
              mdi-server-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-security-network"></i> mdi
              mdi-security-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ip-network"></i> mdi mdi-ip-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-network"></i> mdi
              mdi-folder-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-key-network"></i> mdi
              mdi-folder-key-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-console-network"></i> mdi
              mdi-console-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-network"></i> mdi
              mdi-account-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-access-point-network"></i> mdi
              mdi-access-point-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-iframe-outline"></i> mdi
              mdi-iframe-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-iframe"></i> mdi mdi-iframe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ruler-square"></i> mdi mdi-ruler-square
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-text-outline"></i> mdi
              mdi-folder-text-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-text"></i> mdi mdi-folder-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ballot-recount"></i> mdi
              mdi-ballot-recount
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ballot-recount-outline"></i> mdi
              mdi-ballot-recount-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-home-outline"></i> mdi
              mdi-shield-home-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-lock-outline"></i> mdi
              mdi-shield-lock-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-airplane-outline"></i> mdi
              mdi-shield-airplane-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-check-outline"></i> mdi
              mdi-shield-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-off-outline"></i> mdi
              mdi-shield-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-parachute-outline"></i> mdi
              mdi-parachute-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-parachute"></i> mdi mdi-parachute
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-turnstile-outline"></i> mdi
              mdi-turnstile-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-turnstile"></i> mdi mdi-turnstile
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-sweep-outline"></i> mdi
              mdi-delete-sweep-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-bell-curve"></i> mdi
              mdi-chart-bell-curve
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-math-tan"></i> mdi mdi-math-tan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-math-sin"></i> mdi mdi-math-sin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-math-cos"></i> mdi mdi-math-cos
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-toaster-oven"></i> mdi mdi-toaster-oven
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microwave"></i> mdi mdi-microwave
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ipod"></i> mdi mdi-ipod
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-table-outline"></i> mdi
              mdi-file-table-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-table"></i> mdi mdi-file-table
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-network-outline"></i> mdi
              mdi-account-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-upload-network-outline"></i> mdi
              mdi-upload-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-access-point-network-off"></i> mdi
              mdi-access-point-network-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-console-network-outline"></i> mdi
              mdi-console-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-download-network-outline"></i> mdi
              mdi-download-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-key-network-outline"></i> mdi
              mdi-folder-key-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-network-outline"></i> mdi
              mdi-folder-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-help-network-outline"></i> mdi
              mdi-help-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ip-network-outline"></i> mdi
              mdi-ip-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minus-network-outline"></i> mdi
              mdi-minus-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-outline"></i> mdi
              mdi-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-network-outline"></i> mdi
              mdi-plus-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play-network-outline"></i> mdi
              mdi-play-network-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-progress-alert"></i> mdi
              mdi-progress-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eslint"></i> mdi mdi-eslint
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-leaf-maple"></i> mdi mdi-leaf-maple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-play-outline"></i> mdi
              mdi-clipboard-play-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-play"></i> mdi
              mdi-clipboard-play
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-text-play-outline"></i> mdi
              mdi-clipboard-text-play-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-text-play"></i> mdi
              mdi-clipboard-text-play
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-check-outline"></i> mdi
              mdi-account-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-check"></i> mdi
              mdi-account-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-check"></i> mdi
              mdi-map-marker-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radius-outline"></i> mdi
              mdi-radius-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radius"></i> mdi mdi-radius
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-diameter-variant"></i> mdi
              mdi-diameter-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-diameter-outline"></i> mdi
              mdi-diameter-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-diameter"></i> mdi mdi-diameter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-outline"></i> mdi
              mdi-account-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-off-outline"></i> mdi
              mdi-account-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-multiple-minus-outline"></i> mdi
              mdi-account-multiple-minus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playlist-music-outline"></i> mdi
              mdi-playlist-music-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playlist-music"></i> mdi
              mdi-playlist-music
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-outline"></i> mdi mdi-seat-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat"></i> mdi mdi-seat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-check-outline"></i> mdi
              mdi-calendar-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-remove-outline"></i> mdi
              mdi-calendar-remove-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-text-outline"></i> mdi
              mdi-calendar-text-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-charity"></i> mdi mdi-charity
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-ils"></i> mdi mdi-currency-ils
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watch-vibrate-off"></i> mdi
              mdi-watch-vibrate-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vibrate-off"></i> mdi mdi-vibrate-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-haskell"></i> mdi
              mdi-language-haskell
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-inbox-multiple-outline"></i> mdi
              mdi-inbox-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-circle-outline"></i> mdi
              mdi-account-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wallet-outline"></i> mdi
              mdi-wallet-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-download-outline"></i> mdi
              mdi-cloud-download-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-arrow-right-outline"></i> mdi
              mdi-account-arrow-right-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-arrow-right"></i> mdi
              mdi-account-arrow-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-motorbike"></i> mdi mdi-motorbike
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-outline"></i> mdi mdi-book-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-edit"></i> mdi
              mdi-database-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-circle-outline"></i> mdi
              mdi-eye-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-circle"></i> mdi mdi-eye-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-clock-outline"></i> mdi
              mdi-account-clock-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-clock"></i> mdi
              mdi-account-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-help-rhombus-outline"></i> mdi
              mdi-help-rhombus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-help-rhombus"></i> mdi mdi-help-rhombus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-train-car"></i> mdi mdi-train-car
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-multiple"></i> mdi mdi-car-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mapbox"></i> mdi mdi-mapbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hat-fedora"></i> mdi mdi-hat-fedora
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-target-account"></i> mdi
              mdi-target-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-backspace-outline"></i> mdi
              mdi-backspace-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-top-right"></i> mdi
              mdi-pan-top-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-top-left"></i> mdi mdi-pan-top-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-bottom-left"></i> mdi
              mdi-pan-bottom-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-bottom-right"></i> mdi
              mdi-pan-bottom-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-left"></i> mdi mdi-pan-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-down"></i> mdi mdi-pan-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-right"></i> mdi mdi-pan-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-up"></i> mdi mdi-pan-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-circle-outline"></i> mdi
              mdi-delete-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-remove"></i> mdi mdi-file-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-mark-as-unread"></i> mdi
              mdi-email-mark-as-unread
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-artstation"></i> mdi mdi-artstation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-control"></i> mdi
              mdi-camera-control
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-horizontal"></i> mdi
              mdi-pan-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan-vertical"></i> mdi mdi-pan-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pan"></i> mdi mdi-pan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-barley-off"></i> mdi mdi-barley-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-barn"></i> mdi mdi-barn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drag-variant"></i> mdi mdi-drag-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-library-shelves"></i> mdi
              mdi-library-shelves
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ubisoft"></i> mdi mdi-ubisoft
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gog"></i> mdi mdi-gog
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-open"></i> mdi mdi-menu-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-key-outline"></i> mdi
              mdi-shield-key-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-key"></i> mdi mdi-shield-key
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wrap-disabled"></i> mdi
              mdi-wrap-disabled
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-door"></i> mdi mdi-car-door
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chat-alert"></i> mdi mdi-chat-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chat-processing"></i> mdi
              mdi-chat-processing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chat"></i> mdi mdi-chat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rollupjs"></i> mdi mdi-rollupjs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-brl"></i> mdi mdi-currency-brl
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battlenet"></i> mdi mdi-battlenet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-access-point"></i> mdi mdi-access-point
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account"></i> mdi mdi-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-alert"></i> mdi
              mdi-account-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-box"></i> mdi mdi-account-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-box-multiple"></i> mdi
              mdi-account-box-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-box-outline"></i> mdi
              mdi-account-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-card-details"></i> mdi
              mdi-account-card-details
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-child"></i> mdi
              mdi-account-child
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-child-circle"></i> mdi
              mdi-account-child-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-circle"></i> mdi
              mdi-account-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-convert"></i> mdi
              mdi-account-convert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-details"></i> mdi
              mdi-account-details
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-edit"></i> mdi mdi-account-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-group"></i> mdi
              mdi-account-group
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-heart"></i> mdi
              mdi-account-heart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-key"></i> mdi mdi-account-key
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-minus"></i> mdi
              mdi-account-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-minus-outline"></i> mdi
              mdi-account-minus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-multiple"></i> mdi
              mdi-account-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-multiple-check"></i> mdi
              mdi-account-multiple-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-multiple-minus"></i> mdi
              mdi-account-multiple-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-multiple-plus"></i> mdi
              mdi-account-multiple-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-off"></i> mdi mdi-account-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-plus"></i> mdi mdi-account-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-plus-outline"></i> mdi
              mdi-account-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-remove"></i> mdi
              mdi-account-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-remove-outline"></i> mdi
              mdi-account-remove-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-search"></i> mdi
              mdi-account-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-search-outline"></i> mdi
              mdi-account-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-settings"></i> mdi
              mdi-account-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-star"></i> mdi mdi-account-star
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-supervisor"></i> mdi
              mdi-account-supervisor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-supervisor-circle"></i> mdi
              mdi-account-supervisor-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-account-switch"></i> mdi
              mdi-account-switch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-accusoft"></i> mdi mdi-accusoft
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-adjust"></i> mdi mdi-adjust
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-adobe"></i> mdi mdi-adobe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-air-conditioner"></i> mdi
              mdi-air-conditioner
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-airballoon"></i> mdi mdi-airballoon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-airplane"></i> mdi mdi-airplane
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-airplane-landing"></i> mdi
              mdi-airplane-landing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-airplane-off"></i> mdi mdi-airplane-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-airplane-takeoff"></i> mdi
              mdi-airplane-takeoff
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-airplay"></i> mdi mdi-airplay
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-airport"></i> mdi mdi-airport
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm"></i> mdi mdi-alarm
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm-bell"></i> mdi mdi-alarm-bell
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm-check"></i> mdi mdi-alarm-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm-light"></i> mdi mdi-alarm-light
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm-multiple"></i> mdi
              mdi-alarm-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm-off"></i> mdi mdi-alarm-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm-plus"></i> mdi mdi-alarm-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alarm-snooze"></i> mdi mdi-alarm-snooze
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-album"></i> mdi mdi-album
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert"></i> mdi mdi-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-box"></i> mdi mdi-alert-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-circle"></i> mdi mdi-alert-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-circle-outline"></i> mdi
              mdi-alert-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-decagram"></i> mdi
              mdi-alert-decagram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-octagon"></i> mdi
              mdi-alert-octagon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-octagram"></i> mdi
              mdi-alert-octagram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alert-outline"></i> mdi
              mdi-alert-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alien"></i> mdi mdi-alien
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-all-inclusive"></i> mdi
              mdi-all-inclusive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha"></i> mdi mdi-alpha
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-a"></i> mdi mdi-alpha-a
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-a-box"></i> mdi mdi-alpha-a-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-b"></i> mdi mdi-alpha-b
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-b-box"></i> mdi mdi-alpha-b-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-c"></i> mdi mdi-alpha-c
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-c-box"></i> mdi mdi-alpha-c-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-d"></i> mdi mdi-alpha-d
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-d-box"></i> mdi mdi-alpha-d-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-e"></i> mdi mdi-alpha-e
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-e-box"></i> mdi mdi-alpha-e-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-f"></i> mdi mdi-alpha-f
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-f-box"></i> mdi mdi-alpha-f-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-g"></i> mdi mdi-alpha-g
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-g-box"></i> mdi mdi-alpha-g-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-h"></i> mdi mdi-alpha-h
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-h-box"></i> mdi mdi-alpha-h-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-i"></i> mdi mdi-alpha-i
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-i-box"></i> mdi mdi-alpha-i-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-j"></i> mdi mdi-alpha-j
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-j-box"></i> mdi mdi-alpha-j-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-k"></i> mdi mdi-alpha-k
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-k-box"></i> mdi mdi-alpha-k-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-l"></i> mdi mdi-alpha-l
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-l-box"></i> mdi mdi-alpha-l-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-m"></i> mdi mdi-alpha-m
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-m-box"></i> mdi mdi-alpha-m-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-n"></i> mdi mdi-alpha-n
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-n-box"></i> mdi mdi-alpha-n-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-o"></i> mdi mdi-alpha-o
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-o-box"></i> mdi mdi-alpha-o-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-p"></i> mdi mdi-alpha-p
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-p-box"></i> mdi mdi-alpha-p-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-q"></i> mdi mdi-alpha-q
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-q-box"></i> mdi mdi-alpha-q-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-r"></i> mdi mdi-alpha-r
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-r-box"></i> mdi mdi-alpha-r-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-s"></i> mdi mdi-alpha-s
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-s-box"></i> mdi mdi-alpha-s-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-t"></i> mdi mdi-alpha-t
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-t-box"></i> mdi mdi-alpha-t-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-u"></i> mdi mdi-alpha-u
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-u-box"></i> mdi mdi-alpha-u-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-v"></i> mdi mdi-alpha-v
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-v-box"></i> mdi mdi-alpha-v-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-w"></i> mdi mdi-alpha-w
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-w-box"></i> mdi mdi-alpha-w-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-x"></i> mdi mdi-alpha-x
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-x-box"></i> mdi mdi-alpha-x-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-y"></i> mdi mdi-alpha-y
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-y-box"></i> mdi mdi-alpha-y-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-z"></i> mdi mdi-alpha-z
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alpha-z-box"></i> mdi mdi-alpha-z-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-alphabetical"></i> mdi mdi-alphabetical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-altimeter"></i> mdi mdi-altimeter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-amazon"></i> mdi mdi-amazon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-amazon-alexa"></i> mdi mdi-amazon-alexa
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-amazon-drive"></i> mdi mdi-amazon-drive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ambulance"></i> mdi mdi-ambulance
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ampersand"></i> mdi mdi-ampersand
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-amplifier"></i> mdi mdi-amplifier
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-anchor"></i> mdi mdi-anchor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-android"></i> mdi mdi-android
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-android-auto"></i> mdi mdi-android-auto
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-android-debug-bridge"></i> mdi
              mdi-android-debug-bridge
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-android-head"></i> mdi mdi-android-head
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-android-head"></i> mdi mdi-android-head
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-android-studio"></i> mdi
              mdi-android-studio
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-angle-acute"></i> mdi mdi-angle-acute
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-angle-obtuse"></i> mdi mdi-angle-obtuse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-angle-right"></i> mdi mdi-angle-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-angular"></i> mdi mdi-angular
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-angularjs"></i> mdi mdi-angularjs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-animation"></i> mdi mdi-animation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-animation-outline"></i> mdi
              mdi-animation-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-animation-play"></i> mdi
              mdi-animation-play
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-animation-play-outline"></i> mdi
              mdi-animation-play-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-anvil"></i> mdi mdi-anvil
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple"></i> mdi mdi-apple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-finder"></i> mdi mdi-apple-finder
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-icloud"></i> mdi mdi-apple-icloud
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-ios"></i> mdi mdi-apple-ios
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-keyboard-caps"></i> mdi
              mdi-apple-keyboard-caps
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-keyboard-command"></i> mdi
              mdi-apple-keyboard-command
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-keyboard-control"></i> mdi
              mdi-apple-keyboard-control
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-keyboard-option"></i> mdi
              mdi-apple-keyboard-option
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-keyboard-shift"></i> mdi
              mdi-apple-keyboard-shift
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apple-safari"></i> mdi mdi-apple-safari
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-application"></i> mdi mdi-application
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-apps"></i> mdi mdi-apps
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arch"></i> mdi mdi-arch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-archive"></i> mdi mdi-archive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrange-bring-forward"></i> mdi
              mdi-arrange-bring-forward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrange-bring-to-front"></i> mdi
              mdi-arrange-bring-to-front
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrange-send-backward"></i> mdi
              mdi-arrange-send-backward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrange-send-to-back"></i> mdi
              mdi-arrange-send-to-back
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-all"></i> mdi mdi-arrow-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-bottom-left"></i> mdi
              mdi-arrow-bottom-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-bottom-left-bold-outline"></i> mdi
              mdi-arrow-bottom-left-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-bottom-left-thick"></i> mdi
              mdi-arrow-bottom-left-thick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-bottom-right"></i> mdi
              mdi-arrow-bottom-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-bottom-right-bold-outline"></i>
              mdi mdi-arrow-bottom-right-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-bottom-right-thick"></i> mdi
              mdi-arrow-bottom-right-thick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-collapse"></i> mdi
              mdi-arrow-collapse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-collapse-all"></i> mdi
              mdi-arrow-collapse-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-collapse-down"></i> mdi
              mdi-arrow-collapse-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-collapse-horizontal"></i> mdi
              mdi-arrow-collapse-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-collapse-left"></i> mdi
              mdi-arrow-collapse-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-collapse-right"></i> mdi
              mdi-arrow-collapse-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-collapse-up"></i> mdi
              mdi-arrow-collapse-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-collapse-vertical"></i> mdi
              mdi-arrow-collapse-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-decision"></i> mdi
              mdi-arrow-decision
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-decision-auto"></i> mdi
              mdi-arrow-decision-auto
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-decision-auto-outline"></i> mdi
              mdi-arrow-decision-auto-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-decision-outline"></i> mdi
              mdi-arrow-decision-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down"></i> mdi mdi-arrow-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-bold"></i> mdi
              mdi-arrow-down-bold
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-bold-box"></i> mdi
              mdi-arrow-down-bold-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-bold-box-outline"></i> mdi
              mdi-arrow-down-bold-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-bold-circle"></i> mdi
              mdi-arrow-down-bold-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-bold-circle-outline"></i> mdi
              mdi-arrow-down-bold-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-bold-hexagon-outline"></i>
              mdi mdi-arrow-down-bold-hexagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-bold-outline"></i> mdi
              mdi-arrow-down-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-box"></i> mdi
              mdi-arrow-down-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-drop-circle"></i> mdi
              mdi-arrow-down-drop-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-drop-circle-outline"></i> mdi
              mdi-arrow-down-drop-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-down-thick"></i> mdi
              mdi-arrow-down-thick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand"></i> mdi mdi-arrow-expand
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand-all"></i> mdi
              mdi-arrow-expand-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand-down"></i> mdi
              mdi-arrow-expand-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand-horizontal"></i> mdi
              mdi-arrow-expand-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand-left"></i> mdi
              mdi-arrow-expand-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand-right"></i> mdi
              mdi-arrow-expand-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand-up"></i> mdi
              mdi-arrow-expand-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand-vertical"></i> mdi
              mdi-arrow-expand-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left"></i> mdi mdi-arrow-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-bold"></i> mdi
              mdi-arrow-left-bold
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-bold-box"></i> mdi
              mdi-arrow-left-bold-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-bold-box-outline"></i> mdi
              mdi-arrow-left-bold-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-bold-circle"></i> mdi
              mdi-arrow-left-bold-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-bold-circle-outline"></i> mdi
              mdi-arrow-left-bold-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-bold-hexagon-outline"></i>
              mdi mdi-arrow-left-bold-hexagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-bold-outline"></i> mdi
              mdi-arrow-left-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-box"></i> mdi
              mdi-arrow-left-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-drop-circle"></i> mdi
              mdi-arrow-left-drop-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-drop-circle-outline"></i> mdi
              mdi-arrow-left-drop-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-right-bold-outline"></i> mdi
              mdi-arrow-left-right-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-left-thick"></i> mdi
              mdi-arrow-left-thick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right"></i> mdi mdi-arrow-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-bold"></i> mdi
              mdi-arrow-right-bold
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-bold-box"></i> mdi
              mdi-arrow-right-bold-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-bold-box-outline"></i> mdi
              mdi-arrow-right-bold-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-bold-circle"></i> mdi
              mdi-arrow-right-bold-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-bold-circle-outline"></i>
              mdi mdi-arrow-right-bold-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-bold-hexagon-outline"></i>
              mdi mdi-arrow-right-bold-hexagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-bold-outline"></i> mdi
              mdi-arrow-right-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-box"></i> mdi
              mdi-arrow-right-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-drop-circle"></i> mdi
              mdi-arrow-right-drop-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-drop-circle-outline"></i>
              mdi mdi-arrow-right-drop-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-right-thick"></i> mdi
              mdi-arrow-right-thick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-split-horizontal"></i> mdi
              mdi-arrow-split-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-split-vertical"></i> mdi
              mdi-arrow-split-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-top-left"></i> mdi
              mdi-arrow-top-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-top-left-bold-outline"></i> mdi
              mdi-arrow-top-left-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-top-left-thick"></i> mdi
              mdi-arrow-top-left-thick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-top-right"></i> mdi
              mdi-arrow-top-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-top-right-bold-outline"></i> mdi
              mdi-arrow-top-right-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-top-right-thick"></i> mdi
              mdi-arrow-top-right-thick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-expand-up"></i> mdi
              mdi-arrow-expand-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-bold"></i> mdi
              mdi-arrow-up-bold
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-bold-box"></i> mdi
              mdi-arrow-up-bold-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-bold-box-outline"></i> mdi
              mdi-arrow-up-bold-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-bold-circle"></i> mdi
              mdi-arrow-up-bold-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-bold-circle-outline"></i> mdi
              mdi-arrow-up-bold-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-bold-hexagon-outline"></i> mdi
              mdi-arrow-up-bold-hexagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-bold-outline"></i> mdi
              mdi-arrow-up-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-box"></i> mdi mdi-arrow-up-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-down-bold-outline"></i> mdi
              mdi-arrow-up-down-bold-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-drop-circle"></i> mdi
              mdi-arrow-up-drop-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-drop-circle-outline"></i> mdi
              mdi-arrow-up-drop-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-arrow-up-thick"></i> mdi
              mdi-arrow-up-thick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-artist"></i> mdi mdi-artist
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-aspect-ratio"></i> mdi mdi-aspect-ratio
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-assistant"></i> mdi mdi-assistant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-asterisk"></i> mdi mdi-asterisk
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-at"></i> mdi mdi-at
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-atlassian"></i> mdi mdi-atlassian
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-atom"></i> mdi mdi-atom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-attachment"></i> mdi mdi-attachment
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-audio-video"></i> mdi mdi-audio-video
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-audiobook"></i> mdi mdi-audiobook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-augmented-reality"></i> mdi
              mdi-augmented-reality
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-auto-fix"></i> mdi mdi-auto-fix
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-auto-upload"></i> mdi mdi-auto-upload
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-autorenew"></i> mdi mdi-autorenew
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-av-timer"></i> mdi mdi-av-timer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-axe"></i> mdi mdi-axe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-azure"></i> mdi mdi-azure
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-babel"></i> mdi mdi-babel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-baby"></i> mdi mdi-baby
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-baby-buggy"></i> mdi mdi-baby-buggy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-backburger"></i> mdi mdi-backburger
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-backspace"></i> mdi mdi-backspace
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-backup-restore"></i> mdi
              mdi-backup-restore
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-badminton"></i> mdi mdi-badminton
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-balloon"></i> mdi mdi-balloon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ballot"></i> mdi mdi-ballot
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ballot-outline"></i> mdi
              mdi-ballot-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bandcamp"></i> mdi mdi-bandcamp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bank"></i> mdi mdi-bank
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bank-transfer"></i> mdi
              mdi-bank-transfer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bank-transfer-in"></i> mdi
              mdi-bank-transfer-in
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bank-transfer-out"></i> mdi
              mdi-bank-transfer-out
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-barcode"></i> mdi mdi-barcode
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-barcode-scan"></i> mdi mdi-barcode-scan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-barley"></i> mdi mdi-barley
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-barrel"></i> mdi mdi-barrel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-baseball"></i> mdi mdi-baseball
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-baseball-bat"></i> mdi mdi-baseball-bat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-basecamp"></i> mdi mdi-basecamp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-basket"></i> mdi mdi-basket
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-basket-fill"></i> mdi mdi-basket-fill
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-basket-unfill"></i> mdi
              mdi-basket-unfill
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-basketball"></i> mdi mdi-basketball
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery"></i> mdi mdi-battery
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-10"></i> mdi mdi-battery-10
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-10-bluetooth"></i> mdi
              mdi-battery-10-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-20"></i> mdi mdi-battery-20
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-20-bluetooth"></i> mdi
              mdi-battery-20-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-30"></i> mdi mdi-battery-30
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-30-bluetooth"></i> mdi
              mdi-battery-30-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-40"></i> mdi mdi-battery-40
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-40-bluetooth"></i> mdi
              mdi-battery-40-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-50"></i> mdi mdi-battery-50
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-50-bluetooth"></i> mdi
              mdi-battery-50-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-60"></i> mdi mdi-battery-60
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-60-bluetooth"></i> mdi
              mdi-battery-60-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-70"></i> mdi mdi-battery-70
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-70-bluetooth"></i> mdi
              mdi-battery-70-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-80"></i> mdi mdi-battery-80
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-80-bluetooth"></i> mdi
              mdi-battery-80-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-90"></i> mdi mdi-battery-90
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-90-bluetooth"></i> mdi
              mdi-battery-90-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-alert"></i> mdi
              mdi-battery-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-alert-bluetooth"></i> mdi
              mdi-battery-alert-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-bluetooth"></i> mdi
              mdi-battery-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-bluetooth-variant"></i> mdi
              mdi-battery-bluetooth-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging"></i> mdi
              mdi-battery-charging
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-10"></i> mdi
              mdi-battery-charging-10
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-100"></i> mdi
              mdi-battery-charging-100
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-20"></i> mdi
              mdi-battery-charging-20
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-30"></i> mdi
              mdi-battery-charging-30
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-40"></i> mdi
              mdi-battery-charging-40
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-50"></i> mdi
              mdi-battery-charging-50
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-60"></i> mdi
              mdi-battery-charging-60
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-70"></i> mdi
              mdi-battery-charging-70
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-80"></i> mdi
              mdi-battery-charging-80
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-90"></i> mdi
              mdi-battery-charging-90
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-wireless-alert"></i>
              mdi mdi-battery-charging-wireless-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-charging-wireless-outline"></i>
              mdi mdi-battery-charging-wireless-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-minus"></i> mdi
              mdi-battery-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-negative"></i> mdi
              mdi-battery-negative
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-outline"></i> mdi
              mdi-battery-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-plus"></i> mdi mdi-battery-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-positive"></i> mdi
              mdi-battery-positive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-unknown"></i> mdi
              mdi-battery-unknown
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-battery-unknown-bluetooth"></i> mdi
              mdi-battery-unknown-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-beach"></i> mdi mdi-beach
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-beaker"></i> mdi mdi-beaker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-beats"></i> mdi mdi-beats
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bed-empty"></i> mdi mdi-bed-empty
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-beer"></i> mdi mdi-beer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-behance"></i> mdi mdi-behance
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell"></i> mdi mdi-bell
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-off"></i> mdi mdi-bell-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-off-outline"></i> mdi
              mdi-bell-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-outline"></i> mdi mdi-bell-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-plus"></i> mdi mdi-bell-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-plus-outline"></i> mdi
              mdi-bell-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-ring"></i> mdi mdi-bell-ring
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-ring-outline"></i> mdi
              mdi-bell-ring-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-sleep"></i> mdi mdi-bell-sleep
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bell-sleep-outline"></i> mdi
              mdi-bell-sleep-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-beta"></i> mdi mdi-beta
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-betamax"></i> mdi mdi-betamax
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bible"></i> mdi mdi-bible
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bike"></i> mdi mdi-bike
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bing"></i> mdi mdi-bing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-binoculars"></i> mdi mdi-binoculars
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bio"></i> mdi mdi-bio
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-biohazard"></i> mdi mdi-biohazard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bitbucket"></i> mdi mdi-bitbucket
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bitcoin"></i> mdi mdi-bitcoin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-black-mesa"></i> mdi mdi-black-mesa
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blackberry"></i> mdi mdi-blackberry
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blender"></i> mdi mdi-blender
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blinds"></i> mdi mdi-blinds
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-block-helper"></i> mdi mdi-block-helper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blogger"></i> mdi mdi-blogger
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bluetooth"></i> mdi mdi-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bluetooth-audio"></i> mdi
              mdi-bluetooth-audio
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bluetooth-connect"></i> mdi
              mdi-bluetooth-connect
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bluetooth-off"></i> mdi
              mdi-bluetooth-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bluetooth-settings"></i> mdi
              mdi-bluetooth-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bluetooth-transfer"></i> mdi
              mdi-bluetooth-transfer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blur"></i> mdi mdi-blur
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blur-linear"></i> mdi mdi-blur-linear
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blur-off"></i> mdi mdi-blur-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blur-radial"></i> mdi mdi-blur-radial
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bomb"></i> mdi mdi-bomb
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bomb-off"></i> mdi mdi-bomb-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bone"></i> mdi mdi-bone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book"></i> mdi mdi-book
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-lock"></i> mdi mdi-book-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-lock-open"></i> mdi
              mdi-book-lock-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-minus"></i> mdi mdi-book-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-multiple"></i> mdi
              mdi-book-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-multiple-minus"></i> mdi
              mdi-book-multiple-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-multiple-plus"></i> mdi
              mdi-book-multiple-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-multiple-remove"></i> mdi
              mdi-book-multiple-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-multiple-variant"></i> mdi
              mdi-book-multiple-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-open"></i> mdi mdi-book-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-open-page-variant"></i> mdi
              mdi-book-open-page-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-open-variant"></i> mdi
              mdi-book-open-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-plus"></i> mdi mdi-book-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-remove"></i> mdi mdi-book-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-book-variant"></i> mdi mdi-book-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark"></i> mdi mdi-bookmark
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-check"></i> mdi
              mdi-bookmark-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-minus"></i> mdi
              mdi-bookmark-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-minus-outline"></i> mdi
              mdi-bookmark-minus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-music"></i> mdi
              mdi-bookmark-music
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-off"></i> mdi mdi-bookmark-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-off-outline"></i> mdi
              mdi-bookmark-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-outline"></i> mdi
              mdi-bookmark-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-plus"></i> mdi
              mdi-bookmark-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-plus-outline"></i> mdi
              mdi-bookmark-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bookmark-remove"></i> mdi
              mdi-bookmark-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-boombox"></i> mdi mdi-boombox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bootstrap"></i> mdi mdi-bootstrap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-all"></i> mdi mdi-border-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-all-variant"></i> mdi
              mdi-border-all-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-bottom"></i> mdi
              mdi-border-bottom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-bottom-variant"></i> mdi
              mdi-border-bottom-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-color"></i> mdi mdi-border-color
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-horizontal"></i> mdi
              mdi-border-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-inside"></i> mdi
              mdi-border-inside
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-left"></i> mdi mdi-border-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-left-variant"></i> mdi
              mdi-border-left-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-none"></i> mdi mdi-border-none
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-none-variant"></i> mdi
              mdi-border-none-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-outside"></i> mdi
              mdi-border-outside
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-right"></i> mdi mdi-border-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-right-variant"></i> mdi
              mdi-border-right-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-style"></i> mdi mdi-border-style
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-top"></i> mdi mdi-border-top
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-top-variant"></i> mdi
              mdi-border-top-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-border-vertical"></i> mdi
              mdi-border-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bottle-wine"></i> mdi mdi-bottle-wine
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bow-tie"></i> mdi mdi-bow-tie
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bowl"></i> mdi mdi-bowl
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bowling"></i> mdi mdi-bowling
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-box"></i> mdi mdi-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-box-cutter"></i> mdi mdi-box-cutter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-box-shadow"></i> mdi mdi-box-shadow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-braille"></i> mdi mdi-braille
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brain"></i> mdi mdi-brain
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bridge"></i> mdi mdi-bridge
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase"></i> mdi mdi-briefcase
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-check"></i> mdi
              mdi-briefcase-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-download"></i> mdi
              mdi-briefcase-download
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-edit"></i> mdi
              mdi-briefcase-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-minus"></i> mdi
              mdi-briefcase-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-outline"></i> mdi
              mdi-briefcase-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-plus"></i> mdi
              mdi-briefcase-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-remove"></i> mdi
              mdi-briefcase-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-search"></i> mdi
              mdi-briefcase-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-briefcase-upload"></i> mdi
              mdi-briefcase-upload
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-1"></i> mdi mdi-brightness-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-2"></i> mdi mdi-brightness-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-3"></i> mdi mdi-brightness-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-4"></i> mdi mdi-brightness-4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-5"></i> mdi mdi-brightness-5
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-6"></i> mdi mdi-brightness-6
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-7"></i> mdi mdi-brightness-7
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brightness-auto"></i> mdi
              mdi-brightness-auto
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-broom"></i> mdi mdi-broom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-brush"></i> mdi mdi-brush
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-buddhism"></i> mdi mdi-buddhism
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-buffer"></i> mdi mdi-buffer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bug"></i> mdi mdi-bug
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bug-check"></i> mdi mdi-bug-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bug-check-outline"></i> mdi
              mdi-bug-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bug-outline"></i> mdi mdi-bug-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bulldozer"></i> mdi mdi-bulldozer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bulletin-board"></i> mdi
              mdi-bulletin-board
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bullhorn"></i> mdi mdi-bullhorn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bullhorn-outline"></i> mdi
              mdi-bullhorn-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bullseye-arrow"></i> mdi
              mdi-bullseye-arrow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bus"></i> mdi mdi-bus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bus-alert"></i> mdi mdi-bus-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bus-articulated-end"></i> mdi
              mdi-bus-articulated-end
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bus-articulated-front"></i> mdi
              mdi-bus-articulated-front
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bus-clock"></i> mdi mdi-bus-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bus-double-decker"></i> mdi
              mdi-bus-double-decker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bus-school"></i> mdi mdi-bus-school
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-bus-side"></i> mdi mdi-bus-side
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cached"></i> mdi mdi-cached
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cake"></i> mdi mdi-cake
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cake-layered"></i> mdi mdi-cake-layered
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cake-variant"></i> mdi mdi-cake-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calculator"></i> mdi mdi-calculator
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calculator-variant"></i> mdi
              mdi-calculator-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar"></i> mdi mdi-calendar
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-alert"></i> mdi
              mdi-calendar-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-blank"></i> mdi
              mdi-calendar-blank
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-check"></i> mdi
              mdi-calendar-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-clock"></i> mdi
              mdi-calendar-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-edit"></i> mdi
              mdi-calendar-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-export"></i> mdi
              mdi-calendar-export
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-heart"></i> mdi
              mdi-calendar-heart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-import"></i> mdi
              mdi-calendar-import
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-multiple"></i> mdi
              mdi-calendar-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-multiple-check"></i> mdi
              mdi-calendar-multiple-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-multiselect"></i> mdi
              mdi-calendar-multiselect
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-plus"></i> mdi
              mdi-calendar-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-question"></i> mdi
              mdi-calendar-question
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-range"></i> mdi
              mdi-calendar-range
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-remove"></i> mdi
              mdi-calendar-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-search"></i> mdi
              mdi-calendar-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-star"></i> mdi
              mdi-calendar-star
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-text"></i> mdi
              mdi-calendar-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-today"></i> mdi
              mdi-calendar-today
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-week"></i> mdi
              mdi-calendar-week
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-calendar-week-begin"></i> mdi
              mdi-calendar-week-begin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-call-made"></i> mdi mdi-call-made
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-call-merge"></i> mdi mdi-call-merge
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-call-missed"></i> mdi mdi-call-missed
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-call-received"></i> mdi
              mdi-call-received
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-call-split"></i> mdi mdi-call-split
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camcorder"></i> mdi mdi-camcorder
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camcorder-box"></i> mdi
              mdi-camcorder-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camcorder-box-off"></i> mdi
              mdi-camcorder-box-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camcorder-off"></i> mdi
              mdi-camcorder-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera"></i> mdi mdi-camera
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-account"></i> mdi
              mdi-camera-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-burst"></i> mdi mdi-camera-burst
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-enhance"></i> mdi
              mdi-camera-enhance
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-front"></i> mdi mdi-camera-front
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-front-variant"></i> mdi
              mdi-camera-front-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-gopro"></i> mdi mdi-camera-gopro
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-image"></i> mdi mdi-camera-image
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-iris"></i> mdi mdi-camera-iris
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-metering-center"></i> mdi
              mdi-camera-metering-center
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-metering-matrix"></i> mdi
              mdi-camera-metering-matrix
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-metering-partial"></i> mdi
              mdi-camera-metering-partial
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-metering-spot"></i> mdi
              mdi-camera-metering-spot
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-off"></i> mdi mdi-camera-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-party-mode"></i> mdi
              mdi-camera-party-mode
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-rear"></i> mdi mdi-camera-rear
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-rear-variant"></i> mdi
              mdi-camera-rear-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-switch"></i> mdi
              mdi-camera-switch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-camera-timer"></i> mdi mdi-camera-timer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cancel"></i> mdi mdi-cancel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-candle"></i> mdi mdi-candle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-candycane"></i> mdi mdi-candycane
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cannabis"></i> mdi mdi-cannabis
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-caps-lock"></i> mdi mdi-caps-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car"></i> mdi mdi-car
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-battery"></i> mdi mdi-car-battery
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-connected"></i> mdi
              mdi-car-connected
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-convertible"></i> mdi
              mdi-car-convertible
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-estate"></i> mdi mdi-car-estate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-hatchback"></i> mdi
              mdi-car-hatchback
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-limousine"></i> mdi
              mdi-car-limousine
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-pickup"></i> mdi mdi-car-pickup
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-side"></i> mdi mdi-car-side
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-sports"></i> mdi mdi-car-sports
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-car-wash"></i> mdi mdi-car-wash
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-caravan"></i> mdi mdi-caravan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cards"></i> mdi mdi-cards
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cards-club"></i> mdi mdi-cards-club
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cards-diamond"></i> mdi
              mdi-cards-diamond
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cards-heart"></i> mdi mdi-cards-heart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cards-outline"></i> mdi
              mdi-cards-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cards-playing-outline"></i> mdi
              mdi-cards-playing-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cards-spade"></i> mdi mdi-cards-spade
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cards-variant"></i> mdi
              mdi-cards-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-carrot"></i> mdi mdi-carrot
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart"></i> mdi mdi-cart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart-off"></i> mdi mdi-cart-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart-outline"></i> mdi mdi-cart-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cart-plus"></i> mdi mdi-cart-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-case-sensitive-alt"></i> mdi
              mdi-case-sensitive-alt
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cash"></i> mdi mdi-cash
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cash-100"></i> mdi mdi-cash-100
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cash-multiple"></i> mdi
              mdi-cash-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cash-refund"></i> mdi mdi-cash-refund
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cash-usd"></i> mdi mdi-cash-usd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cassette"></i> mdi mdi-cassette
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cast"></i> mdi mdi-cast
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cast-connected"></i> mdi
              mdi-cast-connected
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cast-off"></i> mdi mdi-cast-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-castle"></i> mdi mdi-castle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cat"></i> mdi mdi-cat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cctv"></i> mdi mdi-cctv
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ceiling-light"></i> mdi
              mdi-ceiling-light
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone"></i> mdi mdi-cellphone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-android"></i> mdi
              mdi-cellphone-android
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-arrow-down"></i> mdi
              mdi-cellphone-arrow-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-basic"></i> mdi
              mdi-cellphone-basic
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-dock"></i> mdi
              mdi-cellphone-dock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-erase"></i> mdi
              mdi-cellphone-erase
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-iphone"></i> mdi
              mdi-cellphone-iphone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-key"></i> mdi
              mdi-cellphone-key
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-link"></i> mdi
              mdi-cellphone-link
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-link-off"></i> mdi
              mdi-cellphone-link-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-lock"></i> mdi
              mdi-cellphone-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-message"></i> mdi
              mdi-cellphone-message
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-off"></i> mdi
              mdi-cellphone-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-screenshot"></i> mdi
              mdi-cellphone-screenshot
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-settings"></i> mdi
              mdi-cellphone-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-settings-variant"></i> mdi
              mdi-cellphone-settings-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-sound"></i> mdi
              mdi-cellphone-sound
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-text"></i> mdi
              mdi-cellphone-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cellphone-wireless"></i> mdi
              mdi-cellphone-wireless
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-certificate"></i> mdi mdi-certificate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chair-school"></i> mdi mdi-chair-school
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-arc"></i> mdi mdi-chart-arc
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-areaspline"></i> mdi
              mdi-chart-areaspline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-bar"></i> mdi mdi-chart-bar
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-bar-stacked"></i> mdi
              mdi-chart-bar-stacked
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-bubble"></i> mdi mdi-chart-bubble
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-donut"></i> mdi mdi-chart-donut
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-donut-variant"></i> mdi
              mdi-chart-donut-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-gantt"></i> mdi mdi-chart-gantt
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-histogram"></i> mdi
              mdi-chart-histogram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-line"></i> mdi mdi-chart-line
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-line-stacked"></i> mdi
              mdi-chart-line-stacked
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-line-variant"></i> mdi
              mdi-chart-line-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-multiline"></i> mdi
              mdi-chart-multiline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-pie"></i> mdi mdi-chart-pie
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-scatterplot-hexbin"></i> mdi
              mdi-chart-scatterplot-hexbin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chart-timeline"></i> mdi
              mdi-chart-timeline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check"></i> mdi mdi-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-all"></i> mdi mdi-check-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-circle"></i> mdi mdi-check-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-circle-outline"></i> mdi
              mdi-check-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-decagram"></i> mdi
              mdi-check-decagram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-check-outline"></i> mdi
              mdi-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbook"></i> mdi mdi-checkbook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-blank"></i> mdi
              mdi-checkbox-blank
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-blank-circle"></i> mdi
              mdi-checkbox-blank-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-blank-circle-outline"></i> mdi
              mdi-checkbox-blank-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-blank-outline"></i> mdi
              mdi-checkbox-blank-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-intermediate"></i> mdi
              mdi-checkbox-intermediate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-marked"></i> mdi
              mdi-checkbox-marked
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-marked-circle"></i> mdi
              mdi-checkbox-marked-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-marked-circle-outline"></i> mdi
              mdi-checkbox-marked-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-marked-outline"></i> mdi
              mdi-checkbox-marked-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-multiple-blank"></i> mdi
              mdi-checkbox-multiple-blank
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-multiple-blank-circle"></i> mdi
              mdi-checkbox-multiple-blank-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i
                class="mdi h5 mr-2 mdi-checkbox-multiple-blank-circle-outline"
              ></i>
              mdi mdi-checkbox-multiple-blank-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-multiple-blank-outline"></i>
              mdi mdi-checkbox-multiple-blank-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-multiple-marked"></i> mdi
              mdi-checkbox-multiple-marked
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-multiple-marked-circle"></i>
              mdi mdi-checkbox-multiple-marked-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i
                class="mdi h5 mr-2 mdi-checkbox-multiple-marked-circle-outline"
              ></i>
              mdi mdi-checkbox-multiple-marked-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkbox-multiple-marked-outline"></i>
              mdi mdi-checkbox-multiple-marked-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-checkerboard"></i> mdi mdi-checkerboard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chemical-weapon"></i> mdi
              mdi-chemical-weapon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chess-bishop"></i> mdi mdi-chess-bishop
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chess-king"></i> mdi mdi-chess-king
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chess-knight"></i> mdi mdi-chess-knight
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chess-pawn"></i> mdi mdi-chess-pawn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chess-queen"></i> mdi mdi-chess-queen
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chess-rook"></i> mdi mdi-chess-rook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-double-down"></i> mdi
              mdi-chevron-double-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-double-left"></i> mdi
              mdi-chevron-double-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-double-right"></i> mdi
              mdi-chevron-double-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-double-up"></i> mdi
              mdi-chevron-double-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-down"></i> mdi mdi-chevron-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-down-box"></i> mdi
              mdi-chevron-down-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-down-box-outline"></i> mdi
              mdi-chevron-down-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-down-circle"></i> mdi
              mdi-chevron-down-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-down-circle-outline"></i> mdi
              mdi-chevron-down-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-left"></i> mdi mdi-chevron-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-left-box"></i> mdi
              mdi-chevron-left-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-left-box-outline"></i> mdi
              mdi-chevron-left-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-left-circle"></i> mdi
              mdi-chevron-left-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-left-circle-outline"></i> mdi
              mdi-chevron-left-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-right"></i> mdi
              mdi-chevron-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-right-box"></i> mdi
              mdi-chevron-right-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-right-box-outline"></i> mdi
              mdi-chevron-right-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-right-circle"></i> mdi
              mdi-chevron-right-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-right-circle-outline"></i> mdi
              mdi-chevron-right-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-up"></i> mdi mdi-chevron-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-up-box"></i> mdi
              mdi-chevron-up-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-up-box-outline"></i> mdi
              mdi-chevron-up-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-up-circle"></i> mdi
              mdi-chevron-up-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chevron-up-circle-outline"></i> mdi
              mdi-chevron-up-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chili-hot"></i> mdi mdi-chili-hot
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chili-medium"></i> mdi mdi-chili-medium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chili-mild"></i> mdi mdi-chili-mild
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-chip"></i> mdi mdi-chip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-christianity"></i> mdi mdi-christianity
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-church"></i> mdi mdi-church
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle"></i> mdi mdi-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-edit-outline"></i> mdi
              mdi-circle-edit-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-medium"></i> mdi
              mdi-circle-medium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-outline"></i> mdi
              mdi-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-slice-1"></i> mdi
              mdi-circle-slice-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-slice-2"></i> mdi
              mdi-circle-slice-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-slice-3"></i> mdi
              mdi-circle-slice-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-slice-4"></i> mdi
              mdi-circle-slice-4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-slice-5"></i> mdi
              mdi-circle-slice-5
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-slice-6"></i> mdi
              mdi-circle-slice-6
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-slice-7"></i> mdi
              mdi-circle-slice-7
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-slice-8"></i> mdi
              mdi-circle-slice-8
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-circle-small"></i> mdi mdi-circle-small
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cisco-webex"></i> mdi mdi-cisco-webex
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-city"></i> mdi mdi-city
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-city-variant"></i> mdi mdi-city-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-city-variant-outline"></i> mdi
              mdi-city-variant-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard"></i> mdi mdi-clipboard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-account"></i> mdi
              mdi-clipboard-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-alert"></i> mdi
              mdi-clipboard-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-arrow-down"></i> mdi
              mdi-clipboard-arrow-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-arrow-left"></i> mdi
              mdi-clipboard-arrow-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-check"></i> mdi
              mdi-clipboard-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-check-outline"></i> mdi
              mdi-clipboard-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-flow"></i> mdi
              mdi-clipboard-flow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-outline"></i> mdi
              mdi-clipboard-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-plus"></i> mdi
              mdi-clipboard-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-pulse"></i> mdi
              mdi-clipboard-pulse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-pulse-outline"></i> mdi
              mdi-clipboard-pulse-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-text"></i> mdi
              mdi-clipboard-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clipboard-text-outline"></i> mdi
              mdi-clipboard-text-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clippy"></i> mdi mdi-clippy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock"></i> mdi mdi-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock-alert"></i> mdi mdi-clock-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock-alert-outline"></i> mdi
              mdi-clock-alert-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock-end"></i> mdi mdi-clock-end
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock-fast"></i> mdi mdi-clock-fast
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock-in"></i> mdi mdi-clock-in
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock-out"></i> mdi mdi-clock-out
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock-outline"></i> mdi
              mdi-clock-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clock-start"></i> mdi mdi-clock-start
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close"></i> mdi mdi-close
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-box"></i> mdi mdi-close-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-box-outline"></i> mdi
              mdi-close-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-circle"></i> mdi mdi-close-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-circle-outline"></i> mdi
              mdi-close-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-network"></i> mdi
              mdi-close-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-octagon"></i> mdi
              mdi-close-octagon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-octagon-outline"></i> mdi
              mdi-close-octagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-close-outline"></i> mdi
              mdi-close-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-closed-caption"></i> mdi
              mdi-closed-caption
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud"></i> mdi mdi-cloud
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-alert"></i> mdi mdi-cloud-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-braces"></i> mdi mdi-cloud-braces
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-check"></i> mdi mdi-cloud-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-circle"></i> mdi mdi-cloud-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-download"></i> mdi
              mdi-cloud-download
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-off-outline"></i> mdi
              mdi-cloud-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-outline"></i> mdi
              mdi-cloud-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-print"></i> mdi mdi-cloud-print
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-print-outline"></i> mdi
              mdi-cloud-print-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-question"></i> mdi
              mdi-cloud-question
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-search"></i> mdi mdi-cloud-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-search-outline"></i> mdi
              mdi-cloud-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-sync"></i> mdi mdi-cloud-sync
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-tags"></i> mdi mdi-cloud-tags
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cloud-upload"></i> mdi mdi-cloud-upload
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-clover"></i> mdi mdi-clover
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-array"></i> mdi mdi-code-array
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-braces"></i> mdi mdi-code-braces
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-brackets"></i> mdi
              mdi-code-brackets
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-equal"></i> mdi mdi-code-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-greater-than"></i> mdi
              mdi-code-greater-than
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-greater-than-or-equal"></i> mdi
              mdi-code-greater-than-or-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-less-than"></i> mdi
              mdi-code-less-than
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-less-than-or-equal"></i> mdi
              mdi-code-less-than-or-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-not-equal"></i> mdi
              mdi-code-not-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-not-equal-variant"></i> mdi
              mdi-code-not-equal-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-parentheses"></i> mdi
              mdi-code-parentheses
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-string"></i> mdi mdi-code-string
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-tags"></i> mdi mdi-code-tags
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-code-tags-check"></i> mdi
              mdi-code-tags-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-codepen"></i> mdi mdi-codepen
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-coffee"></i> mdi mdi-coffee
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-coffee-outline"></i> mdi
              mdi-coffee-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-coffee-to-go"></i> mdi mdi-coffee-to-go
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cogs"></i> mdi mdi-cogs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-coin"></i> mdi mdi-coin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-coins"></i> mdi mdi-coins
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-collage"></i> mdi mdi-collage
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-collapse-all"></i> mdi mdi-collapse-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-collapse-all-outline"></i> mdi
              mdi-collapse-all-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-color-helper"></i> mdi mdi-color-helper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment"></i> mdi mdi-comment
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-account"></i> mdi
              mdi-comment-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-account-outline"></i> mdi
              mdi-comment-account-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-alert"></i> mdi
              mdi-comment-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-alert-outline"></i> mdi
              mdi-comment-alert-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-arrow-left"></i> mdi
              mdi-comment-arrow-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-arrow-left-outline"></i> mdi
              mdi-comment-arrow-left-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-arrow-right"></i> mdi
              mdi-comment-arrow-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-arrow-right-outline"></i> mdi
              mdi-comment-arrow-right-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-check"></i> mdi
              mdi-comment-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-check-outline"></i> mdi
              mdi-comment-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-eye"></i> mdi mdi-comment-eye
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-eye-outline"></i> mdi
              mdi-comment-eye-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-multiple"></i> mdi
              mdi-comment-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-multiple-outline"></i> mdi
              mdi-comment-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-outline"></i> mdi
              mdi-comment-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-plus"></i> mdi mdi-comment-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-plus-outline"></i> mdi
              mdi-comment-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-processing"></i> mdi
              mdi-comment-processing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-processing-outline"></i> mdi
              mdi-comment-processing-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-question"></i> mdi
              mdi-comment-question
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-question-outline"></i> mdi
              mdi-comment-question-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-remove"></i> mdi
              mdi-comment-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-remove-outline"></i> mdi
              mdi-comment-remove-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-search"></i> mdi
              mdi-comment-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-search-outline"></i> mdi
              mdi-comment-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-text"></i> mdi mdi-comment-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-text-multiple"></i> mdi
              mdi-comment-text-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-text-multiple-outline"></i> mdi
              mdi-comment-text-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-comment-text-outline"></i> mdi
              mdi-comment-text-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-compare"></i> mdi mdi-compare
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-compass"></i> mdi mdi-compass
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-compass-outline"></i> mdi
              mdi-compass-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-console"></i> mdi mdi-console
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-console-line"></i> mdi mdi-console-line
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contact-mail"></i> mdi mdi-contact-mail
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contacts"></i> mdi mdi-contacts
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contain"></i> mdi mdi-contain
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contain-end"></i> mdi mdi-contain-end
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contain-start"></i> mdi
              mdi-contain-start
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-copy"></i> mdi mdi-content-copy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-cut"></i> mdi mdi-content-cut
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-duplicate"></i> mdi
              mdi-content-duplicate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-paste"></i> mdi
              mdi-content-paste
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-save"></i> mdi mdi-content-save
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-save-all"></i> mdi
              mdi-content-save-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-save-outline"></i> mdi
              mdi-content-save-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-save-settings"></i> mdi
              mdi-content-save-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-content-save-settings-outline"></i> mdi
              mdi-content-save-settings-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contrast"></i> mdi mdi-contrast
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contrast-box"></i> mdi mdi-contrast-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-contrast-circle"></i> mdi
              mdi-contrast-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cookie"></i> mdi mdi-cookie
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-copyright"></i> mdi mdi-copyright
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cordova"></i> mdi mdi-cordova
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-corn"></i> mdi mdi-corn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-counter"></i> mdi mdi-counter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cow"></i> mdi mdi-cow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crane"></i> mdi mdi-crane
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-creation"></i> mdi mdi-creation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-credit-card"></i> mdi mdi-credit-card
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-credit-card-multiple"></i> mdi
              mdi-credit-card-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-credit-card-off"></i> mdi
              mdi-credit-card-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-credit-card-plus"></i> mdi
              mdi-credit-card-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-credit-card-refund"></i> mdi
              mdi-credit-card-refund
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-credit-card-scan"></i> mdi
              mdi-credit-card-scan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-credit-card-settings"></i> mdi
              mdi-credit-card-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crop"></i> mdi mdi-crop
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crop-free"></i> mdi mdi-crop-free
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crop-landscape"></i> mdi
              mdi-crop-landscape
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crop-portrait"></i> mdi
              mdi-crop-portrait
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crop-rotate"></i> mdi mdi-crop-rotate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crop-square"></i> mdi mdi-crop-square
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crosshairs"></i> mdi mdi-crosshairs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crosshairs-gps"></i> mdi
              mdi-crosshairs-gps
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crown"></i> mdi mdi-crown
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cryengine"></i> mdi mdi-cryengine
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-crystal-ball"></i> mdi mdi-crystal-ball
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cube"></i> mdi mdi-cube
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cube-outline"></i> mdi mdi-cube-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cube-send"></i> mdi mdi-cube-send
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cube-unfolded"></i> mdi
              mdi-cube-unfolded
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cup"></i> mdi mdi-cup
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cup-off"></i> mdi mdi-cup-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cup-water"></i> mdi mdi-cup-water
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cupcake"></i> mdi mdi-cupcake
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-curling"></i> mdi mdi-curling
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-bdt"></i> mdi mdi-currency-bdt
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-btc"></i> mdi mdi-currency-btc
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-chf"></i> mdi mdi-currency-chf
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-cny"></i> mdi mdi-currency-cny
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-eth"></i> mdi mdi-currency-eth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-eur"></i> mdi mdi-currency-eur
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-gbp"></i> mdi mdi-currency-gbp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-inr"></i> mdi mdi-currency-inr
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-jpy"></i> mdi mdi-currency-jpy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-krw"></i> mdi mdi-currency-krw
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-kzt"></i> mdi mdi-currency-kzt
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-ngn"></i> mdi mdi-currency-ngn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-php"></i> mdi mdi-currency-php
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-rub"></i> mdi mdi-currency-rub
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-sign"></i> mdi
              mdi-currency-sign
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-try"></i> mdi mdi-currency-try
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-twd"></i> mdi mdi-currency-twd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-usd"></i> mdi mdi-currency-usd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-currency-usd-off"></i> mdi
              mdi-currency-usd-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-current-ac"></i> mdi mdi-current-ac
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-current-dc"></i> mdi mdi-current-dc
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cursor-default"></i> mdi
              mdi-cursor-default
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cursor-default-outline"></i> mdi
              mdi-cursor-default-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cursor-move"></i> mdi mdi-cursor-move
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cursor-pointer"></i> mdi
              mdi-cursor-pointer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-cursor-text"></i> mdi mdi-cursor-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database"></i> mdi mdi-database
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-check"></i> mdi
              mdi-database-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-export"></i> mdi
              mdi-database-export
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-import"></i> mdi
              mdi-database-import
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-lock"></i> mdi
              mdi-database-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-minus"></i> mdi
              mdi-database-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-plus"></i> mdi
              mdi-database-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-database-search"></i> mdi
              mdi-database-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-death-star"></i> mdi mdi-death-star
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-death-star-variant"></i> mdi
              mdi-death-star-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-debian"></i> mdi mdi-debian
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-debug-step-into"></i> mdi
              mdi-debug-step-into
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-debug-step-into"></i> mdi
              mdi-debug-step-into
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-debug-step-out"></i> mdi
              mdi-debug-step-out
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-debug-step-over"></i> mdi
              mdi-debug-step-over
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-decagram"></i> mdi mdi-decagram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-decagram-outline"></i> mdi
              mdi-decagram-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-decimal-decrease"></i> mdi
              mdi-decimal-decrease
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-decimal-increase"></i> mdi
              mdi-decimal-increase
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete"></i> mdi mdi-delete
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-circle"></i> mdi
              mdi-delete-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-empty"></i> mdi mdi-delete-empty
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-forever"></i> mdi
              mdi-delete-forever
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-outline"></i> mdi
              mdi-delete-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-restore"></i> mdi
              mdi-delete-restore
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-sweep"></i> mdi mdi-delete-sweep
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delete-variant"></i> mdi
              mdi-delete-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-delta"></i> mdi mdi-delta
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-desk-lamp"></i> mdi mdi-desk-lamp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-deskphone"></i> mdi mdi-deskphone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-desktop-classic"></i> mdi
              mdi-desktop-classic
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-desktop-mac"></i> mdi mdi-desktop-mac
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-desktop-mac-dashboard"></i> mdi
              mdi-desktop-mac-dashboard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-desktop-tower"></i> mdi
              mdi-desktop-tower
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-desktop-tower-monitor"></i> mdi
              mdi-desktop-tower-monitor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-details"></i> mdi mdi-details
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-developer-board"></i> mdi
              mdi-developer-board
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-deviantart"></i> mdi mdi-deviantart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dialpad"></i> mdi mdi-dialpad
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-diamond"></i> mdi mdi-diamond
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-1"></i> mdi mdi-dice-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-2"></i> mdi mdi-dice-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-3"></i> mdi mdi-dice-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-4"></i> mdi mdi-dice-4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-5"></i> mdi mdi-dice-5
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-6"></i> mdi mdi-dice-6
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-d10"></i> mdi mdi-dice-d10
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-d12"></i> mdi mdi-dice-d12
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-d20"></i> mdi mdi-dice-d20
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-d4"></i> mdi mdi-dice-d4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-d6"></i> mdi mdi-dice-d6
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-d8"></i> mdi mdi-dice-d8
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dice-multiple"></i> mdi
              mdi-dice-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dictionary"></i> mdi mdi-dictionary
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dip-switch"></i> mdi mdi-dip-switch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-directions"></i> mdi mdi-directions
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-directions-fork"></i> mdi
              mdi-directions-fork
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-disc"></i> mdi mdi-disc
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-disc-alert"></i> mdi mdi-disc-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-disc-player"></i> mdi mdi-disc-player
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-discord"></i> mdi mdi-discord
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dishwasher"></i> mdi mdi-dishwasher
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-disqus"></i> mdi mdi-disqus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-disqus-outline"></i> mdi
              mdi-disqus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-division"></i> mdi mdi-division
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-division-box"></i> mdi mdi-division-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dlna"></i> mdi mdi-dlna
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dna"></i> mdi mdi-dna
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dns"></i> mdi mdi-dns
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-do-not-disturb"></i> mdi
              mdi-do-not-disturb
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-do-not-disturb-off"></i> mdi
              mdi-do-not-disturb-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-docker"></i> mdi mdi-docker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-doctor"></i> mdi mdi-doctor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dog"></i> mdi mdi-dog
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dog-service"></i> mdi mdi-dog-service
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dog-side"></i> mdi mdi-dog-side
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dolby"></i> mdi mdi-dolby
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-domain"></i> mdi mdi-domain
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-donkey"></i> mdi mdi-donkey
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-door"></i> mdi mdi-door
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-door-closed"></i> mdi mdi-door-closed
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-door-open"></i> mdi mdi-door-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-doorbell-video"></i> mdi
              mdi-doorbell-video
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dot-net"></i> mdi mdi-dot-net
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dots-horizontal"></i> mdi
              mdi-dots-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dots-horizontal-circle"></i> mdi
              mdi-dots-horizontal-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dots-vertical"></i> mdi
              mdi-dots-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dots-vertical-circle"></i> mdi
              mdi-dots-vertical-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-douban"></i> mdi mdi-douban
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-download"></i> mdi mdi-download
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-download-multiple"></i> mdi
              mdi-download-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-download-network"></i> mdi
              mdi-download-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drag"></i> mdi mdi-drag
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drag-horizontal"></i> mdi
              mdi-drag-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drag-vertical"></i> mdi
              mdi-drag-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drawing"></i> mdi mdi-drawing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drawing-box"></i> mdi mdi-drawing-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dribbble"></i> mdi mdi-dribbble
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dribbble-box"></i> mdi mdi-dribbble-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drone"></i> mdi mdi-drone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dropbox"></i> mdi mdi-dropbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-drupal"></i> mdi mdi-drupal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-duck"></i> mdi mdi-duck
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-dumbbell"></i> mdi mdi-dumbbell
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ear-hearing"></i> mdi mdi-ear-hearing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ear-hearing-off"></i> mdi
              mdi-ear-hearing-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-earth"></i> mdi mdi-earth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-earth-box"></i> mdi mdi-earth-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-earth-box-off"></i> mdi
              mdi-earth-box-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-earth-off"></i> mdi mdi-earth-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-edge"></i> mdi mdi-edge
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-egg"></i> mdi mdi-egg
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-egg-easter"></i> mdi mdi-egg-easter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eight-track"></i> mdi mdi-eight-track
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eject"></i> mdi mdi-eject
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-elephant"></i> mdi mdi-elephant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-elevation-decline"></i> mdi
              mdi-elevation-decline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-elevation-rise"></i> mdi
              mdi-elevation-rise
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-elevator"></i> mdi mdi-elevator
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email"></i> mdi mdi-email
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-alert"></i> mdi mdi-email-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-check"></i> mdi mdi-email-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-check-outline"></i> mdi
              mdi-email-check-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-lock"></i> mdi mdi-email-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-open"></i> mdi mdi-email-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-open-outline"></i> mdi
              mdi-email-open-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-outline"></i> mdi
              mdi-email-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-plus"></i> mdi mdi-email-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-plus-outline"></i> mdi
              mdi-email-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-search"></i> mdi mdi-email-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-search-outline"></i> mdi
              mdi-email-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-email-variant"></i> mdi
              mdi-email-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ember"></i> mdi mdi-ember
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emby"></i> mdi mdi-emby
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-outline"></i> mdi
              mdi-emoticon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-cool-outline"></i> mdi
              mdi-emoticon-cool-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-dead-outline"></i> mdi
              mdi-emoticon-dead-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-devil-outline"></i> mdi
              mdi-emoticon-devil-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-excited-outline"></i> mdi
              mdi-emoticon-excited-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-happy-outline"></i> mdi
              mdi-emoticon-happy-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-neutral-outline"></i> mdi
              mdi-emoticon-neutral-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-poop"></i> mdi
              mdi-emoticon-poop
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-sad-outline"></i> mdi
              mdi-emoticon-sad-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-emoticon-tongue"></i> mdi
              mdi-emoticon-tongue
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-engine"></i> mdi mdi-engine
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-engine-off"></i> mdi mdi-engine-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-engine-off-outline"></i> mdi
              mdi-engine-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-engine-outline"></i> mdi
              mdi-engine-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-equal"></i> mdi mdi-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-equal-box"></i> mdi mdi-equal-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eraser"></i> mdi mdi-eraser
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eraser-variant"></i> mdi
              mdi-eraser-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-escalator"></i> mdi mdi-escalator
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-et"></i> mdi mdi-et
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ethereum"></i> mdi mdi-ethereum
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ethernet"></i> mdi mdi-ethernet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ethernet-cable"></i> mdi
              mdi-ethernet-cable
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ethernet-cable-off"></i> mdi
              mdi-ethernet-cable-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-etsy"></i> mdi mdi-etsy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ev-station"></i> mdi mdi-ev-station
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eventbrite"></i> mdi mdi-eventbrite
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-evernote"></i> mdi mdi-evernote
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-exclamation"></i> mdi mdi-exclamation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-exit-run"></i> mdi mdi-exit-run
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-exit-to-app"></i> mdi mdi-exit-to-app
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-expand-all"></i> mdi mdi-expand-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-expand-all-outline"></i> mdi
              mdi-expand-all-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-exponent"></i> mdi mdi-exponent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-exponent-box"></i> mdi mdi-exponent-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-export"></i> mdi mdi-export
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye"></i> mdi mdi-eye
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-off"></i> mdi mdi-eye-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-off-outline"></i> mdi
              mdi-eye-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-outline"></i> mdi mdi-eye-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-plus"></i> mdi mdi-eye-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-plus-outline"></i> mdi
              mdi-eye-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-settings"></i> mdi mdi-eye-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eye-settings-outline"></i> mdi
              mdi-eye-settings-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eyedropper"></i> mdi mdi-eyedropper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-eyedropper-variant"></i> mdi
              mdi-eyedropper-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-face"></i> mdi mdi-face
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-face-profile"></i> mdi mdi-face-profile
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-facebook"></i> mdi mdi-facebook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-facebook-box"></i> mdi mdi-facebook-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-facebook-messenger"></i> mdi
              mdi-facebook-messenger
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-facebook-workplace"></i> mdi
              mdi-facebook-workplace
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-factory"></i> mdi mdi-factory
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fan"></i> mdi mdi-fan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fan-off"></i> mdi mdi-fan-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fast-forward"></i> mdi mdi-fast-forward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fast-forward-outline"></i> mdi
              mdi-fast-forward-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fax"></i> mdi mdi-fax
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-feather"></i> mdi mdi-feather
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-feature-search"></i> mdi
              mdi-feature-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-feature-search-outline"></i> mdi
              mdi-feature-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fedora"></i> mdi mdi-fedora
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ferry"></i> mdi mdi-ferry
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file"></i> mdi mdi-file
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-account"></i> mdi mdi-file-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-alert"></i> mdi mdi-file-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-alert-outline"></i> mdi
              mdi-file-alert-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-cabinet"></i> mdi mdi-file-cabinet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-chart"></i> mdi mdi-file-chart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-check"></i> mdi mdi-file-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-cloud"></i> mdi mdi-file-cloud
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-compare"></i> mdi mdi-file-compare
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-delimited"></i> mdi
              mdi-file-delimited
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-document"></i> mdi
              mdi-file-document
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-document-box"></i> mdi
              mdi-file-document-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-document-box-multiple"></i> mdi
              mdi-file-document-box-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-document-box-multiple-outline"></i>
              mdi mdi-file-document-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-document-box-outline"></i> mdi
              mdi-file-document-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-document-outline"></i> mdi
              mdi-file-document-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-download"></i> mdi
              mdi-file-download
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-download-outline"></i> mdi
              mdi-file-download-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-excel"></i> mdi mdi-file-excel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-excel-box"></i> mdi
              mdi-file-excel-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-export"></i> mdi mdi-file-export
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-find"></i> mdi mdi-file-find
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-hidden"></i> mdi mdi-file-hidden
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-image"></i> mdi mdi-file-image
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-import"></i> mdi mdi-file-import
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-lock"></i> mdi mdi-file-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-move"></i> mdi mdi-file-move
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-multiple"></i> mdi
              mdi-file-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-music"></i> mdi mdi-file-music
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-outline"></i> mdi mdi-file-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-pdf"></i> mdi mdi-file-pdf
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-pdf-box"></i> mdi mdi-file-pdf-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-percent"></i> mdi mdi-file-percent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-plus"></i> mdi mdi-file-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-powerpoint"></i> mdi
              mdi-file-powerpoint
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-powerpoint-box"></i> mdi
              mdi-file-powerpoint-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-presentation-box"></i> mdi
              mdi-file-presentation-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-question"></i> mdi
              mdi-file-question
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-replace"></i> mdi mdi-file-replace
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-replace-outline"></i> mdi
              mdi-file-replace-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-restore"></i> mdi mdi-file-restore
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-send"></i> mdi mdi-file-send
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-tree"></i> mdi mdi-file-tree
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-undo"></i> mdi mdi-file-undo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-upload"></i> mdi mdi-file-upload
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-upload-outline"></i> mdi
              mdi-file-upload-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-video"></i> mdi mdi-file-video
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-word"></i> mdi mdi-file-word
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-word-box"></i> mdi
              mdi-file-word-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-file-xml"></i> mdi mdi-file-xml
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-film"></i> mdi mdi-film
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-filmstrip"></i> mdi mdi-filmstrip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-filmstrip-off"></i> mdi
              mdi-filmstrip-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-filter"></i> mdi mdi-filter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-filter-outline"></i> mdi
              mdi-filter-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-filter-remove"></i> mdi
              mdi-filter-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-filter-remove-outline"></i> mdi
              mdi-filter-remove-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-filter-variant"></i> mdi
              mdi-filter-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-finance"></i> mdi mdi-finance
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-find-replace"></i> mdi mdi-find-replace
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fingerprint"></i> mdi mdi-fingerprint
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fire"></i> mdi mdi-fire
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fire-truck"></i> mdi mdi-fire-truck
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fire-truck"></i> mdi mdi-fire-truck
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-firebase"></i> mdi mdi-firebase
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-firefox"></i> mdi mdi-firefox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fish"></i> mdi mdi-fish
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flag"></i> mdi mdi-flag
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flag-checkered"></i> mdi
              mdi-flag-checkered
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flag-outline"></i> mdi mdi-flag-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flag-triangle"></i> mdi
              mdi-flag-triangle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flag-variant"></i> mdi mdi-flag-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flag-variant-outline"></i> mdi
              mdi-flag-variant-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flash"></i> mdi mdi-flash
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flash-auto"></i> mdi mdi-flash-auto
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flash-circle"></i> mdi mdi-flash-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flash-off"></i> mdi mdi-flash-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flash-outline"></i> mdi
              mdi-flash-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flash-red-eye"></i> mdi
              mdi-flash-red-eye
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flashlight"></i> mdi mdi-flashlight
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flashlight-off"></i> mdi
              mdi-flashlight-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flask"></i> mdi mdi-flask
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flask-empty"></i> mdi mdi-flask-empty
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flask-empty-outline"></i> mdi
              mdi-flask-empty-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flask-outline"></i> mdi
              mdi-flask-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flattr"></i> mdi mdi-flattr
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flip-to-back"></i> mdi mdi-flip-to-back
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flip-to-front"></i> mdi
              mdi-flip-to-front
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-floor-lamp"></i> mdi mdi-floor-lamp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-floor-plan"></i> mdi mdi-floor-plan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-floppy"></i> mdi mdi-floppy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-floppy-variant"></i> mdi
              mdi-floppy-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flower"></i> mdi mdi-flower
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flower-outline"></i> mdi
              mdi-flower-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flower-tulip"></i> mdi mdi-flower-tulip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-flower-tulip-outline"></i> mdi
              mdi-flower-tulip-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder"></i> mdi mdi-folder
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-account"></i> mdi
              mdi-folder-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-clock"></i> mdi mdi-folder-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-clock-outline"></i> mdi
              mdi-folder-clock-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-download"></i> mdi
              mdi-folder-download
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-edit"></i> mdi mdi-folder-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-google-drive"></i> mdi
              mdi-folder-google-drive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-image"></i> mdi mdi-folder-image
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-key"></i> mdi mdi-folder-key
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-lock"></i> mdi mdi-folder-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-lock-open"></i> mdi
              mdi-folder-lock-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-move"></i> mdi mdi-folder-move
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-multiple"></i> mdi
              mdi-folder-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-multiple-image"></i> mdi
              mdi-folder-multiple-image
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-multiple-outline"></i> mdi
              mdi-folder-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-open"></i> mdi mdi-folder-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-outline"></i> mdi
              mdi-folder-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-plus"></i> mdi mdi-folder-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-remove"></i> mdi
              mdi-folder-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-search"></i> mdi
              mdi-folder-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-search-outline"></i> mdi
              mdi-folder-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-star"></i> mdi mdi-folder-star
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-folder-upload"></i> mdi
              mdi-folder-upload
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-font-awesome"></i> mdi mdi-font-awesome
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-food"></i> mdi mdi-food
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-food-apple"></i> mdi mdi-food-apple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-food-croissant"></i> mdi
              mdi-food-croissant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-food-fork-drink"></i> mdi
              mdi-food-fork-drink
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-food-off"></i> mdi mdi-food-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-food-variant"></i> mdi mdi-food-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-football"></i> mdi mdi-football
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-football-australian"></i> mdi
              mdi-football-australian
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-football-helmet"></i> mdi
              mdi-football-helmet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-forklift"></i> mdi mdi-forklift
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-align-bottom"></i> mdi
              mdi-format-align-bottom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-align-center"></i> mdi
              mdi-format-align-center
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-align-justify"></i> mdi
              mdi-format-align-justify
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-align-left"></i> mdi
              mdi-format-align-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-align-middle"></i> mdi
              mdi-format-align-middle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-align-right"></i> mdi
              mdi-format-align-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-align-top"></i> mdi
              mdi-format-align-top
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-annotation-minus"></i> mdi
              mdi-format-annotation-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-annotation-plus"></i> mdi
              mdi-format-annotation-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-bold"></i> mdi mdi-format-bold
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-clear"></i> mdi mdi-format-clear
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-color-fill"></i> mdi
              mdi-format-color-fill
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-color-text"></i> mdi
              mdi-format-color-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-columns"></i> mdi
              mdi-format-columns
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-float-center"></i> mdi
              mdi-format-float-center
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-float-left"></i> mdi
              mdi-format-float-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-float-none"></i> mdi
              mdi-format-float-none
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-float-right"></i> mdi
              mdi-format-float-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-font"></i> mdi mdi-format-font
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-font-size-decrease"></i> mdi
              mdi-format-font-size-decrease
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-font-size-increase"></i> mdi
              mdi-format-font-size-increase
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-1"></i> mdi
              mdi-format-header-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-2"></i> mdi
              mdi-format-header-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-3"></i> mdi
              mdi-format-header-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-4"></i> mdi
              mdi-format-header-4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-5"></i> mdi
              mdi-format-header-5
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-6"></i> mdi
              mdi-format-header-6
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-decrease"></i> mdi
              mdi-format-header-decrease
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-equal"></i> mdi
              mdi-format-header-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-increase"></i> mdi
              mdi-format-header-increase
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-header-pound"></i> mdi
              mdi-format-header-pound
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-horizontal-align-center"></i> mdi
              mdi-format-horizontal-align-center
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-horizontal-align-left"></i> mdi
              mdi-format-horizontal-align-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-horizontal-align-right"></i> mdi
              mdi-format-horizontal-align-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-indent-decrease"></i> mdi
              mdi-format-indent-decrease
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-indent-increase"></i> mdi
              mdi-format-indent-increase
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-italic"></i> mdi
              mdi-format-italic
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-letter-case"></i> mdi
              mdi-format-letter-case
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-letter-case-lower"></i> mdi
              mdi-format-letter-case-lower
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-letter-case-upper"></i> mdi
              mdi-format-letter-case-upper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-line-spacing"></i> mdi
              mdi-format-line-spacing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-line-style"></i> mdi
              mdi-format-line-style
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-line-weight"></i> mdi
              mdi-format-line-weight
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-list-bulleted"></i> mdi
              mdi-format-list-bulleted
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-list-bulleted-type"></i> mdi
              mdi-format-list-bulleted-type
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-list-checkbox"></i> mdi
              mdi-format-list-checkbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-list-checks"></i> mdi
              mdi-format-list-checks
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-list-numbered"></i> mdi
              mdi-format-list-numbered
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-page-break"></i> mdi
              mdi-format-page-break
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-paint"></i> mdi mdi-format-paint
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-paragraph"></i> mdi
              mdi-format-paragraph
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-pilcrow"></i> mdi
              mdi-format-pilcrow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-quote-close"></i> mdi
              mdi-format-quote-close
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-quote-open"></i> mdi
              mdi-format-quote-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-rotate-90"></i> mdi
              mdi-format-rotate-90
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-section"></i> mdi
              mdi-format-section
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-size"></i> mdi mdi-format-size
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-strikethrough"></i> mdi
              mdi-format-strikethrough
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-strikethrough-variant"></i> mdi
              mdi-format-strikethrough-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-subscript"></i> mdi
              mdi-format-subscript
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-superscript"></i> mdi
              mdi-format-superscript
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-text"></i> mdi mdi-format-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-textdirection-l-to-r"></i> mdi
              mdi-format-textdirection-l-to-r
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-textdirection-r-to-l"></i> mdi
              mdi-format-textdirection-r-to-l
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-title"></i> mdi mdi-format-title
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-underline"></i> mdi
              mdi-format-underline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-vertical-align-bottom"></i> mdi
              mdi-format-vertical-align-bottom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-vertical-align-center"></i> mdi
              mdi-format-vertical-align-center
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-vertical-align-top"></i> mdi
              mdi-format-vertical-align-top
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-wrap-inline"></i> mdi
              mdi-format-wrap-inline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-wrap-square"></i> mdi
              mdi-format-wrap-square
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-wrap-tight"></i> mdi
              mdi-format-wrap-tight
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-format-wrap-top-bottom"></i> mdi
              mdi-format-wrap-top-bottom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-forum"></i> mdi mdi-forum
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-forum-outline"></i> mdi
              mdi-forum-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-forward"></i> mdi mdi-forward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fountain"></i> mdi mdi-fountain
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-foursquare"></i> mdi mdi-foursquare
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-freebsd"></i> mdi mdi-freebsd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fridge-outline"></i> mdi
              mdi-fridge-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fridge"></i> mdi mdi-fridge
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fridge-bottom"></i> mdi
              mdi-fridge-bottom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fridge-top"></i> mdi mdi-fridge-top
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fuel"></i> mdi mdi-fuel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fullscreen"></i> mdi mdi-fullscreen
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-fullscreen-exit"></i> mdi
              mdi-fullscreen-exit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-function"></i> mdi mdi-function
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-function-variant"></i> mdi
              mdi-function-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gamepad"></i> mdi mdi-gamepad
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gamepad-variant"></i> mdi
              mdi-gamepad-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-garage"></i> mdi mdi-garage
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-garage-alert"></i> mdi mdi-garage-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-garage-open"></i> mdi mdi-garage-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gas-cylinder"></i> mdi mdi-gas-cylinder
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gas-station"></i> mdi mdi-gas-station
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gate"></i> mdi mdi-gate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gate-and"></i> mdi mdi-gate-and
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gate-nand"></i> mdi mdi-gate-nand
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gate-nor"></i> mdi mdi-gate-nor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gate-not"></i> mdi mdi-gate-not
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gate-or"></i> mdi mdi-gate-or
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gate-xnor"></i> mdi mdi-gate-xnor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gate-xor"></i> mdi mdi-gate-xor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gauge"></i> mdi mdi-gauge
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gauge-empty"></i> mdi mdi-gauge-empty
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gauge-full"></i> mdi mdi-gauge-full
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gauge-low"></i> mdi mdi-gauge-low
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gavel"></i> mdi mdi-gavel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gender-female"></i> mdi
              mdi-gender-female
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gender-male"></i> mdi mdi-gender-male
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gender-male-female"></i> mdi
              mdi-gender-male-female
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gender-transgender"></i> mdi
              mdi-gender-transgender
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gentoo"></i> mdi mdi-gentoo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture"></i> mdi mdi-gesture
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-double-tap"></i> mdi
              mdi-gesture-double-tap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-pinch"></i> mdi
              mdi-gesture-pinch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-spread"></i> mdi
              mdi-gesture-spread
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-swipe-down"></i> mdi
              mdi-gesture-swipe-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-swipe-horizontal"></i> mdi
              mdi-gesture-swipe-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-swipe-left"></i> mdi
              mdi-gesture-swipe-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-swipe-right"></i> mdi
              mdi-gesture-swipe-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-swipe-up"></i> mdi
              mdi-gesture-swipe-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-swipe-vertical"></i> mdi
              mdi-gesture-swipe-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-tap"></i> mdi mdi-gesture-tap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-two-double-tap"></i> mdi
              mdi-gesture-two-double-tap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gesture-two-tap"></i> mdi
              mdi-gesture-two-tap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ghost"></i> mdi mdi-ghost
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ghost-off"></i> mdi mdi-ghost-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gift"></i> mdi mdi-gift
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-git"></i> mdi mdi-git
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-github-box"></i> mdi mdi-github-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-github-circle"></i> mdi
              mdi-github-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-github-face"></i> mdi mdi-github-face
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-glass-cocktail"></i> mdi
              mdi-glass-cocktail
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-glass-flute"></i> mdi mdi-glass-flute
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-glass-mug"></i> mdi mdi-glass-mug
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-glass-stange"></i> mdi mdi-glass-stange
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-glass-tulip"></i> mdi mdi-glass-tulip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-glass-wine"></i> mdi mdi-glass-wine
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-glassdoor"></i> mdi mdi-glassdoor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-glasses"></i> mdi mdi-glasses
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-globe-model"></i> mdi mdi-globe-model
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gmail"></i> mdi mdi-gmail
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gnome"></i> mdi mdi-gnome
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-golf"></i> mdi mdi-golf
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gondola"></i> mdi mdi-gondola
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google"></i> mdi mdi-google
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-allo"></i> mdi mdi-google-allo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-analytics"></i> mdi
              mdi-google-analytics
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-assistant"></i> mdi
              mdi-google-assistant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-cardboard"></i> mdi
              mdi-google-cardboard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-chrome"></i> mdi
              mdi-google-chrome
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-circles"></i> mdi
              mdi-google-circles
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-circles-communities"></i> mdi
              mdi-google-circles-communities
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-circles-extended"></i> mdi
              mdi-google-circles-extended
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-circles-group"></i> mdi
              mdi-google-circles-group
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-controller"></i> mdi
              mdi-google-controller
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-controller-off"></i> mdi
              mdi-google-controller-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-drive"></i> mdi mdi-google-drive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-earth"></i> mdi mdi-google-earth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-fit"></i> mdi mdi-google-fit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-glass"></i> mdi mdi-google-glass
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-hangouts"></i> mdi
              mdi-google-hangouts
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-home"></i> mdi mdi-google-home
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-keep"></i> mdi mdi-google-keep
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-lens"></i> mdi mdi-google-lens
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-maps"></i> mdi mdi-google-maps
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-nearby"></i> mdi
              mdi-google-nearby
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-pages"></i> mdi mdi-google-pages
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-photos"></i> mdi
              mdi-google-photos
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-physical-web"></i> mdi
              mdi-google-physical-web
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-play"></i> mdi mdi-google-play
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-plus"></i> mdi mdi-google-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-plus-box"></i> mdi
              mdi-google-plus-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-spreadsheet"></i> mdi
              mdi-google-spreadsheet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-translate"></i> mdi
              mdi-google-translate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-google-wallet"></i> mdi
              mdi-google-wallet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gpu"></i> mdi mdi-gpu
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-gradient"></i> mdi mdi-gradient
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-graphql"></i> mdi mdi-graphql
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-grease-pencil"></i> mdi
              mdi-grease-pencil
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-greater-than"></i> mdi mdi-greater-than
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-greater-than-or-equal"></i> mdi
              mdi-greater-than-or-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-grid"></i> mdi mdi-grid
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-grid-large"></i> mdi mdi-grid-large
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-grid-off"></i> mdi mdi-grid-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-group"></i> mdi mdi-group
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-guitar-acoustic"></i> mdi
              mdi-guitar-acoustic
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-guitar-electric"></i> mdi
              mdi-guitar-electric
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-guitar-pick"></i> mdi mdi-guitar-pick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-guitar-pick-outline"></i> mdi
              mdi-guitar-pick-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-guy-fawkes-mask"></i> mdi
              mdi-guy-fawkes-mask
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hackernews"></i> mdi mdi-hackernews
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hail"></i> mdi mdi-hail
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hamburger"></i> mdi mdi-hamburger
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hammer"></i> mdi mdi-hammer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hand"></i> mdi mdi-hand
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hand-okay"></i> mdi mdi-hand-okay
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hand-peace"></i> mdi mdi-hand-peace
            </div>

            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hockey-sticks"></i> mdi
              mdi-hockey-sticks
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hololens"></i> mdi mdi-hololens
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home"></i> mdi mdi-home
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-account"></i> mdi mdi-home-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-alert"></i> mdi mdi-home-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-assistant"></i> mdi
              mdi-home-assistant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-automation"></i> mdi
              mdi-home-automation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-circle"></i> mdi mdi-home-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-currency-usd"></i> mdi
              mdi-home-currency-usd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-heart"></i> mdi mdi-home-heart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-lock"></i> mdi mdi-home-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-lock-open"></i> mdi
              mdi-home-lock-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-map-marker"></i> mdi
              mdi-home-map-marker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-minus"></i> mdi mdi-home-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-modern"></i> mdi mdi-home-modern
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-outline"></i> mdi mdi-home-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-plus"></i> mdi mdi-home-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-home-variant"></i> mdi mdi-home-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hook"></i> mdi mdi-hook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hook-off"></i> mdi mdi-hook-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hops"></i> mdi mdi-hops
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-horseshoe"></i> mdi mdi-horseshoe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hospital"></i> mdi mdi-hospital
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hospital-building"></i> mdi
              mdi-hospital-building
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hospital-marker"></i> mdi
              mdi-hospital-marker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hot-tub"></i> mdi mdi-hot-tub
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hotel"></i> mdi mdi-hotel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-houzz"></i> mdi mdi-houzz
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-houzz-box"></i> mdi mdi-houzz-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-hulu"></i> mdi mdi-hulu
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human"></i> mdi mdi-human
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-child"></i> mdi mdi-human-child
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-female"></i> mdi mdi-human-female
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-female-boy"></i> mdi
              mdi-human-female-boy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-female-female"></i> mdi
              mdi-human-female-female
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-female-girl"></i> mdi
              mdi-human-female-girl
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-greeting"></i> mdi
              mdi-human-greeting
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-handsdown"></i> mdi
              mdi-human-handsdown
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-handsup"></i> mdi
              mdi-human-handsup
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-male"></i> mdi mdi-human-male
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-male-boy"></i> mdi
              mdi-human-male-boy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-male-female"></i> mdi
              mdi-human-male-female
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-male-girl"></i> mdi
              mdi-human-male-girl
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-male-male"></i> mdi
              mdi-human-male-male
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-human-pregnant"></i> mdi
              mdi-human-pregnant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-humble-bundle"></i> mdi
              mdi-humble-bundle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ice-cream"></i> mdi mdi-ice-cream
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image"></i> mdi mdi-image
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-album"></i> mdi mdi-image-album
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-area"></i> mdi mdi-image-area
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-area-close"></i> mdi
              mdi-image-area-close
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-broken"></i> mdi mdi-image-broken
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-broken-variant"></i> mdi
              mdi-image-broken-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter"></i> mdi mdi-image-filter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-black-white"></i> mdi
              mdi-image-filter-black-white
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-center-focus"></i> mdi
              mdi-image-filter-center-focus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-center-focus-weak"></i> mdi
              mdi-image-filter-center-focus-weak
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-drama"></i> mdi
              mdi-image-filter-drama
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-frames"></i> mdi
              mdi-image-filter-frames
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-hdr"></i> mdi
              mdi-image-filter-hdr
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-none"></i> mdi
              mdi-image-filter-none
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-tilt-shift"></i> mdi
              mdi-image-filter-tilt-shift
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-filter-vintage"></i> mdi
              mdi-image-filter-vintage
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-move"></i> mdi mdi-image-move
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-multiple"></i> mdi
              mdi-image-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-off"></i> mdi mdi-image-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-outline"></i> mdi
              mdi-image-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-plus"></i> mdi mdi-image-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-search"></i> mdi mdi-image-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-image-search-outline"></i> mdi
              mdi-image-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-import"></i> mdi mdi-import
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-inbox"></i> mdi mdi-inbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-inbox-arrow-down"></i> mdi
              mdi-inbox-arrow-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-inbox-arrow-up"></i> mdi
              mdi-inbox-arrow-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-inbox-multiple"></i> mdi
              mdi-inbox-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-incognito"></i> mdi mdi-incognito
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-infinity"></i> mdi mdi-infinity
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-information"></i> mdi mdi-information
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-information-outline"></i> mdi
              mdi-information-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-information-variant"></i> mdi
              mdi-information-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-instagram"></i> mdi mdi-instagram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-instapaper"></i> mdi mdi-instapaper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-internet-explorer"></i> mdi
              mdi-internet-explorer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-invert-colors"></i> mdi
              mdi-invert-colors
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ip"></i> mdi mdi-ip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-islam"></i> mdi mdi-islam
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-itunes"></i> mdi mdi-itunes
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-jeepney"></i> mdi mdi-jeepney
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-jira"></i> mdi mdi-jira
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-jquery"></i> mdi mdi-jquery
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-jsfiddle"></i> mdi mdi-jsfiddle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-json"></i> mdi mdi-json
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-judaism"></i> mdi mdi-judaism
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-karate"></i> mdi mdi-karate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keg"></i> mdi mdi-keg
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-kettle"></i> mdi mdi-kettle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-key"></i> mdi mdi-key
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-key-change"></i> mdi mdi-key-change
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-key-minus"></i> mdi mdi-key-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-key-plus"></i> mdi mdi-key-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-key-remove"></i> mdi mdi-key-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-key-variant"></i> mdi mdi-key-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard"></i> mdi mdi-keyboard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-backspace"></i> mdi
              mdi-keyboard-backspace
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-caps"></i> mdi
              mdi-keyboard-caps
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-close"></i> mdi
              mdi-keyboard-close
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-off"></i> mdi mdi-keyboard-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-outline"></i> mdi
              mdi-keyboard-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-return"></i> mdi
              mdi-keyboard-return
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-settings"></i> mdi
              mdi-keyboard-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-settings-outline"></i> mdi
              mdi-keyboard-settings-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-tab"></i> mdi mdi-keyboard-tab
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-keyboard-variant"></i> mdi
              mdi-keyboard-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-kickstarter"></i> mdi mdi-kickstarter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-knife"></i> mdi mdi-knife
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-knife-military"></i> mdi
              mdi-knife-military
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-kodi"></i> mdi mdi-kodi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-label"></i> mdi mdi-label
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-label-off"></i> mdi mdi-label-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-label-off-outline"></i> mdi
              mdi-label-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-label-outline"></i> mdi
              mdi-label-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-label-variant"></i> mdi
              mdi-label-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-label-variant-outline"></i> mdi
              mdi-label-variant-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ladybug"></i> mdi mdi-ladybug
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lambda"></i> mdi mdi-lambda
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lamp"></i> mdi mdi-lamp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lan"></i> mdi mdi-lan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lan-connect"></i> mdi mdi-lan-connect
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lan-disconnect"></i> mdi
              mdi-lan-disconnect
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lan-pending"></i> mdi mdi-lan-pending
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-c"></i> mdi mdi-language-c
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-cpp"></i> mdi mdi-language-cpp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-csharp"></i> mdi
              mdi-language-csharp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-css3"></i> mdi
              mdi-language-css3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-go"></i> mdi mdi-language-go
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-html5"></i> mdi
              mdi-language-html5
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-java"></i> mdi
              mdi-language-java
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-javascript"></i> mdi
              mdi-language-javascript
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-lua"></i> mdi mdi-language-lua
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-php"></i> mdi mdi-language-php
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-python"></i> mdi
              mdi-language-python
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-python-text"></i> mdi
              mdi-language-python-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-r"></i> mdi mdi-language-r
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-ruby-on-rails"></i> mdi
              mdi-language-ruby-on-rails
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-swift"></i> mdi
              mdi-language-swift
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-language-typescript"></i> mdi
              mdi-language-typescript
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-laptop"></i> mdi mdi-laptop
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-laptop-chromebook"></i> mdi
              mdi-laptop-chromebook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-laptop-mac"></i> mdi mdi-laptop-mac
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-laptop-off"></i> mdi mdi-laptop-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-laptop-windows"></i> mdi
              mdi-laptop-windows
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-laravel"></i> mdi mdi-laravel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lastfm"></i> mdi mdi-lastfm
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lastpass"></i> mdi mdi-lastpass
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-launch"></i> mdi mdi-launch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lava-lamp"></i> mdi mdi-lava-lamp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-layers"></i> mdi mdi-layers
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-layers-off"></i> mdi mdi-layers-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-layers-off-outline"></i> mdi
              mdi-layers-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-layers-outline"></i> mdi
              mdi-layers-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lead-pencil"></i> mdi mdi-lead-pencil
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-leaf"></i> mdi mdi-leaf
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-led-off"></i> mdi mdi-led-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-led-on"></i> mdi mdi-led-on
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-led-outline"></i> mdi mdi-led-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-led-strip"></i> mdi mdi-led-strip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-led-variant-off"></i> mdi
              mdi-led-variant-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-led-variant-on"></i> mdi
              mdi-led-variant-on
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-led-variant-outline"></i> mdi
              mdi-led-variant-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-less-than"></i> mdi mdi-less-than
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-less-than-or-equal"></i> mdi
              mdi-less-than-or-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-library"></i> mdi mdi-library
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-library-books"></i> mdi
              mdi-library-books
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-library-music"></i> mdi
              mdi-library-music
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-library-plus"></i> mdi mdi-library-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lifebuoy"></i> mdi mdi-lifebuoy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-light-switch"></i> mdi mdi-light-switch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lightbulb"></i> mdi mdi-lightbulb
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lightbulb-on"></i> mdi mdi-lightbulb-on
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lightbulb-on-outline"></i> mdi
              mdi-lightbulb-on-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lightbulb-outline"></i> mdi
              mdi-lightbulb-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lighthouse"></i> mdi mdi-lighthouse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lighthouse-on"></i> mdi
              mdi-lighthouse-on
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link-variant"></i> mdi mdi-link-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-link-variant-off"></i> mdi
              mdi-link-variant-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-linkedin"></i> mdi mdi-linkedin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-linkedin-box"></i> mdi mdi-linkedin-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-linux"></i> mdi mdi-linux
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-linux-mint"></i> mdi mdi-linux-mint
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-litecoin"></i> mdi mdi-litecoin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-loading"></i> mdi mdi-loading
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock"></i> mdi mdi-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-alert"></i> mdi mdi-lock-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-clock"></i> mdi mdi-lock-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-open"></i> mdi mdi-lock-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-open-outline"></i> mdi
              mdi-lock-open-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-outline"></i> mdi mdi-lock-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-pattern"></i> mdi mdi-lock-pattern
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-plus"></i> mdi mdi-lock-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-question"></i> mdi
              mdi-lock-question
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-reset"></i> mdi mdi-lock-reset
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lock-smart"></i> mdi mdi-lock-smart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-locker"></i> mdi mdi-locker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-locker-multiple"></i> mdi
              mdi-locker-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-login-variant"></i> mdi
              mdi-login-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-logout-variant"></i> mdi
              mdi-logout-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-looks"></i> mdi mdi-looks
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-loop"></i> mdi mdi-loop
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-loupe"></i> mdi mdi-loupe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lumx"></i> mdi mdi-lumx
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-lyft"></i> mdi mdi-lyft
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnet"></i> mdi mdi-magnet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnet-on"></i> mdi mdi-magnet-on
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnify"></i> mdi mdi-magnify
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnify-close"></i> mdi
              mdi-magnify-close
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnify-minus"></i> mdi
              mdi-magnify-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnify-minus-cursor"></i> mdi
              mdi-magnify-minus-cursor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnify-minus-outline"></i> mdi
              mdi-magnify-minus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnify-plus"></i> mdi mdi-magnify-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnify-plus-cursor"></i> mdi
              mdi-magnify-plus-cursor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-magnify-plus-outline"></i> mdi
              mdi-magnify-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mail-ru"></i> mdi mdi-mail-ru
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mailbox"></i> mdi mdi-mailbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map"></i> mdi mdi-map
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-legend"></i> mdi mdi-map-legend
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker"></i> mdi mdi-map-marker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-circle"></i> mdi
              mdi-map-marker-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-distance"></i> mdi
              mdi-map-marker-distance
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-minus"></i> mdi
              mdi-map-marker-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-multiple"></i> mdi
              mdi-map-marker-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-off"></i> mdi
              mdi-map-marker-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-outline"></i> mdi
              mdi-map-marker-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-plus"></i> mdi
              mdi-map-marker-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-marker-radius"></i> mdi
              mdi-map-marker-radius
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-minus"></i> mdi mdi-map-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-outline"></i> mdi mdi-map-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-plus"></i> mdi mdi-map-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-search"></i> mdi mdi-map-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-map-search-outline"></i> mdi
              mdi-map-search-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-margin"></i> mdi mdi-margin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-markdown"></i> mdi mdi-markdown
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-marker"></i> mdi mdi-marker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-marker-check"></i> mdi mdi-marker-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mastodon"></i> mdi mdi-mastodon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mastodon-variant"></i> mdi
              mdi-mastodon-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-material-design"></i> mdi
              mdi-material-design
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-material-ui"></i> mdi mdi-material-ui
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-math-compass"></i> mdi mdi-math-compass
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-matrix"></i> mdi mdi-matrix
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-maxcdn"></i> mdi mdi-maxcdn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-medal"></i> mdi mdi-medal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-medical-bag"></i> mdi mdi-medical-bag
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-medium"></i> mdi mdi-medium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-meetup"></i> mdi mdi-meetup
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-memory"></i> mdi mdi-memory
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu"></i> mdi mdi-menu
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-down"></i> mdi mdi-menu-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-down-outline"></i> mdi
              mdi-menu-down-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-left"></i> mdi mdi-menu-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-left-outline"></i> mdi
              mdi-menu-left-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-right"></i> mdi mdi-menu-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-right-outline"></i> mdi
              mdi-menu-right-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-swap"></i> mdi mdi-menu-swap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-swap-outline"></i> mdi
              mdi-menu-swap-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-up"></i> mdi mdi-menu-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-menu-up-outline"></i> mdi
              mdi-menu-up-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message"></i> mdi mdi-message
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-alert"></i> mdi
              mdi-message-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-alert-outline"></i> mdi
              mdi-message-alert-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-bulleted"></i> mdi
              mdi-message-bulleted
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-bulleted-off"></i> mdi
              mdi-message-bulleted-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-draw"></i> mdi mdi-message-draw
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-image"></i> mdi
              mdi-message-image
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-outline"></i> mdi
              mdi-message-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-plus"></i> mdi mdi-message-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-processing"></i> mdi
              mdi-message-processing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-reply"></i> mdi
              mdi-message-reply
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-reply-text"></i> mdi
              mdi-message-reply-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-settings"></i> mdi
              mdi-message-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-settings-variant"></i> mdi
              mdi-message-settings-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-text"></i> mdi mdi-message-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-text-outline"></i> mdi
              mdi-message-text-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-message-video"></i> mdi
              mdi-message-video
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-meteor"></i> mdi mdi-meteor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-metronome"></i> mdi mdi-metronome
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-metronome-tick"></i> mdi
              mdi-metronome-tick
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-micro-sd"></i> mdi mdi-micro-sd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microphone"></i> mdi mdi-microphone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microphone-minus"></i> mdi
              mdi-microphone-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microphone-off"></i> mdi
              mdi-microphone-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microphone-outline"></i> mdi
              mdi-microphone-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microphone-plus"></i> mdi
              mdi-microphone-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microphone-settings"></i> mdi
              mdi-microphone-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microphone-variant"></i> mdi
              mdi-microphone-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microphone-variant-off"></i> mdi
              mdi-microphone-variant-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microscope"></i> mdi mdi-microscope
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microsoft"></i> mdi mdi-microsoft
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-microsoft-dynamics"></i> mdi
              mdi-microsoft-dynamics
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-midi"></i> mdi mdi-midi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-midi-port"></i> mdi mdi-midi-port
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minecraft"></i> mdi mdi-minecraft
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mini-sd"></i> mdi mdi-mini-sd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minidisc"></i> mdi mdi-minidisc
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minus"></i> mdi mdi-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minus-box"></i> mdi mdi-minus-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minus-box-outline"></i> mdi
              mdi-minus-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minus-circle"></i> mdi mdi-minus-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minus-circle-outline"></i> mdi
              mdi-minus-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-minus-network"></i> mdi
              mdi-minus-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mixcloud"></i> mdi mdi-mixcloud
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mixed-reality"></i> mdi
              mdi-mixed-reality
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mixer"></i> mdi mdi-mixer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-monitor"></i> mdi mdi-monitor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-monitor-cellphone"></i> mdi
              mdi-monitor-cellphone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-monitor-cellphone-star"></i> mdi
              mdi-monitor-cellphone-star
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-monitor-dashboard"></i> mdi
              mdi-monitor-dashboard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-monitor-multiple"></i> mdi
              mdi-monitor-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-more"></i> mdi mdi-more
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mouse"></i> mdi mdi-mouse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mouse-bluetooth"></i> mdi
              mdi-mouse-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mouse-off"></i> mdi mdi-mouse-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mouse-variant"></i> mdi
              mdi-mouse-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mouse-variant-off"></i> mdi
              mdi-mouse-variant-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-move-resize"></i> mdi mdi-move-resize
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-move-resize-variant"></i> mdi
              mdi-move-resize-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-movie"></i> mdi mdi-movie
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-movie-roll"></i> mdi mdi-movie-roll
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-muffin"></i> mdi mdi-muffin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-multiplication"></i> mdi
              mdi-multiplication
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-multiplication-box"></i> mdi
              mdi-multiplication-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mushroom"></i> mdi mdi-mushroom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-mushroom-outline"></i> mdi
              mdi-mushroom-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music"></i> mdi mdi-music
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-box"></i> mdi mdi-music-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-box-outline"></i> mdi
              mdi-music-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-circle"></i> mdi mdi-music-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-circle-outline"></i> mdi
              mdi-music-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note"></i> mdi mdi-music-note
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note-bluetooth"></i> mdi
              mdi-music-note-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note-bluetooth-off"></i> mdi
              mdi-music-note-bluetooth-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note-eighth"></i> mdi
              mdi-music-note-eighth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note-half"></i> mdi
              mdi-music-note-half
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note-off"></i> mdi
              mdi-music-note-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note-quarter"></i> mdi
              mdi-music-note-quarter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note-sixteenth"></i> mdi
              mdi-music-note-sixteenth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-note-whole"></i> mdi
              mdi-music-note-whole
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-music-off"></i> mdi mdi-music-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nas"></i> mdi mdi-nas
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nativescript"></i> mdi mdi-nativescript
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nature"></i> mdi mdi-nature
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nature-people"></i> mdi
              mdi-nature-people
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-navigation"></i> mdi mdi-navigation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-near-me"></i> mdi mdi-near-me
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-needle"></i> mdi mdi-needle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-netflix"></i> mdi mdi-netflix
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network"></i> mdi mdi-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-1"></i> mdi
              mdi-network-strength-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-1-alert"></i> mdi
              mdi-network-strength-1-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-2"></i> mdi
              mdi-network-strength-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-2-alert"></i> mdi
              mdi-network-strength-2-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-3"></i> mdi
              mdi-network-strength-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-3-alert"></i> mdi
              mdi-network-strength-3-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-4"></i> mdi
              mdi-network-strength-4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-4-alert"></i> mdi
              mdi-network-strength-4-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-off"></i> mdi
              mdi-network-strength-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-off-outline"></i> mdi
              mdi-network-strength-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-network-strength-outline"></i> mdi
              mdi-network-strength-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-new-box"></i> mdi mdi-new-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-newspaper"></i> mdi mdi-newspaper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nfc"></i> mdi mdi-nfc
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nfc-tap"></i> mdi mdi-nfc-tap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nfc-variant"></i> mdi mdi-nfc-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ninja"></i> mdi mdi-ninja
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nintendo-switch"></i> mdi
              mdi-nintendo-switch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nodejs"></i> mdi mdi-nodejs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-not-equal"></i> mdi mdi-not-equal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-not-equal-variant"></i> mdi
              mdi-not-equal-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-note"></i> mdi mdi-note
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-note-multiple"></i> mdi
              mdi-note-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-note-multiple-outline"></i> mdi
              mdi-note-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-note-outline"></i> mdi mdi-note-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-note-plus"></i> mdi mdi-note-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-note-plus-outline"></i> mdi
              mdi-note-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-note-text"></i> mdi mdi-note-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-notebook"></i> mdi mdi-notebook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-notification-clear-all"></i> mdi
              mdi-notification-clear-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-npm"></i> mdi mdi-npm
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-npm-variant"></i> mdi mdi-npm-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-npm-variant-outline"></i> mdi
              mdi-npm-variant-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nuke"></i> mdi mdi-nuke
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-null"></i> mdi mdi-null
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric"></i> mdi mdi-numeric
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-0"></i> mdi mdi-numeric-0
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-0-box"></i> mdi
              mdi-numeric-0-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-0-box-multiple-outline"></i> mdi
              mdi-numeric-0-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-0-box-outline"></i> mdi
              mdi-numeric-0-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-1"></i> mdi mdi-numeric-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-1-box"></i> mdi
              mdi-numeric-1-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-1-box-multiple-outline"></i> mdi
              mdi-numeric-1-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-1-box-outline"></i> mdi
              mdi-numeric-1-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-2"></i> mdi mdi-numeric-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-2-box"></i> mdi
              mdi-numeric-2-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-2-box-multiple-outline"></i> mdi
              mdi-numeric-2-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-2-box-outline"></i> mdi
              mdi-numeric-2-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-3"></i> mdi mdi-numeric-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-3-box"></i> mdi
              mdi-numeric-3-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-3-box-multiple-outline"></i> mdi
              mdi-numeric-3-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-3-box-outline"></i> mdi
              mdi-numeric-3-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-4"></i> mdi mdi-numeric-4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-4-box"></i> mdi
              mdi-numeric-4-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-4-box-multiple-outline"></i> mdi
              mdi-numeric-4-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-4-box-outline"></i> mdi
              mdi-numeric-4-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-5"></i> mdi mdi-numeric-5
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-5-box"></i> mdi
              mdi-numeric-5-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-5-box-multiple-outline"></i> mdi
              mdi-numeric-5-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-5-box-outline"></i> mdi
              mdi-numeric-5-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-6"></i> mdi mdi-numeric-6
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-6-box"></i> mdi
              mdi-numeric-6-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-6-box-multiple-outline"></i> mdi
              mdi-numeric-6-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-6-box-outline"></i> mdi
              mdi-numeric-6-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-7"></i> mdi mdi-numeric-7
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-7-box"></i> mdi
              mdi-numeric-7-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-7-box-multiple-outline"></i> mdi
              mdi-numeric-7-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-7-box-outline"></i> mdi
              mdi-numeric-7-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-8"></i> mdi mdi-numeric-8
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-8-box"></i> mdi
              mdi-numeric-8-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-8-box-multiple-outline"></i> mdi
              mdi-numeric-8-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-8-box-outline"></i> mdi
              mdi-numeric-8-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9"></i> mdi mdi-numeric-9
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-box"></i> mdi
              mdi-numeric-9-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-box-multiple-outline"></i> mdi
              mdi-numeric-9-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-box-outline"></i> mdi
              mdi-numeric-9-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-plus-box"></i> mdi
              mdi-numeric-9-plus-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i
                class="mdi h5 mr-2 mdi-numeric-9-plus-box-multiple-outline"
              ></i>
              mdi mdi-numeric-9-plus-box-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-numeric-9-plus-box-outline"></i> mdi
              mdi-numeric-9-plus-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nut"></i> mdi mdi-nut
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-nutrition"></i> mdi mdi-nutrition
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-oar"></i> mdi mdi-oar
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-octagon"></i> mdi mdi-octagon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-octagon-outline"></i> mdi
              mdi-octagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-octagram"></i> mdi mdi-octagram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-octagram-outline"></i> mdi
              mdi-octagram-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-odnoklassniki"></i> mdi
              mdi-odnoklassniki
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-office"></i> mdi mdi-office
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-office-building"></i> mdi
              mdi-office-building
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-oil"></i> mdi mdi-oil
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-oil-temperature"></i> mdi
              mdi-oil-temperature
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-omega"></i> mdi mdi-omega
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-onedrive"></i> mdi mdi-onedrive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-onenote"></i> mdi mdi-onenote
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-onepassword"></i> mdi mdi-onepassword
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-opacity"></i> mdi mdi-opacity
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-open-in-app"></i> mdi mdi-open-in-app
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-open-in-new"></i> mdi mdi-open-in-new
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-openid"></i> mdi mdi-openid
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-opera"></i> mdi mdi-opera
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-orbit"></i> mdi mdi-orbit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-origin"></i> mdi mdi-origin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ornament"></i> mdi mdi-ornament
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ornament-variant"></i> mdi
              mdi-ornament-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-owl"></i> mdi mdi-owl
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-package"></i> mdi mdi-package
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-package-down"></i> mdi mdi-package-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-package-up"></i> mdi mdi-package-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-package-variant"></i> mdi
              mdi-package-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-package-variant-closed"></i> mdi
              mdi-package-variant-closed
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-page-first"></i> mdi mdi-page-first
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-page-last"></i> mdi mdi-page-last
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-page-layout-body"></i> mdi
              mdi-page-layout-body
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-page-layout-footer"></i> mdi
              mdi-page-layout-footer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-page-layout-header"></i> mdi
              mdi-page-layout-header
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-page-layout-sidebar-left"></i> mdi
              mdi-page-layout-sidebar-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-page-layout-sidebar-right"></i> mdi
              mdi-page-layout-sidebar-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-palette"></i> mdi mdi-palette
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-palette-advanced"></i> mdi
              mdi-palette-advanced
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-palette-swatch"></i> mdi
              mdi-palette-swatch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-panda"></i> mdi mdi-panda
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pandora"></i> mdi mdi-pandora
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-panorama"></i> mdi mdi-panorama
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-panorama-fisheye"></i> mdi
              mdi-panorama-fisheye
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-panorama-horizontal"></i> mdi
              mdi-panorama-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-panorama-vertical"></i> mdi
              mdi-panorama-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-panorama-wide-angle"></i> mdi
              mdi-panorama-wide-angle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-paper-cut-vertical"></i> mdi
              mdi-paper-cut-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-paperclip"></i> mdi mdi-paperclip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-parking"></i> mdi mdi-parking
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-passport"></i> mdi mdi-passport
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-patreon"></i> mdi mdi-patreon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pause"></i> mdi mdi-pause
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pause-circle"></i> mdi mdi-pause-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pause-circle-outline"></i> mdi
              mdi-pause-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pause-octagon"></i> mdi
              mdi-pause-octagon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pause-octagon-outline"></i> mdi
              mdi-pause-octagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-paw"></i> mdi mdi-paw
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-paw-off"></i> mdi mdi-paw-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-paypal"></i> mdi mdi-paypal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-peace"></i> mdi mdi-peace
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pen"></i> mdi mdi-pen
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pencil"></i> mdi mdi-pencil
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pencil-box"></i> mdi mdi-pencil-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pencil-box-outline"></i> mdi
              mdi-pencil-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pencil-circle"></i> mdi
              mdi-pencil-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pencil-circle-outline"></i> mdi
              mdi-pencil-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pencil-lock"></i> mdi mdi-pencil-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pencil-off"></i> mdi mdi-pencil-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pentagon"></i> mdi mdi-pentagon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pentagon-outline"></i> mdi
              mdi-pentagon-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-percent"></i> mdi mdi-percent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-periodic-table"></i> mdi
              mdi-periodic-table
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-periodic-table-co2"></i> mdi
              mdi-periodic-table-co2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-periscope"></i> mdi mdi-periscope
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pharmacy"></i> mdi mdi-pharmacy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone"></i> mdi mdi-phone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-bluetooth"></i> mdi
              mdi-phone-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-classic"></i> mdi
              mdi-phone-classic
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-forward"></i> mdi
              mdi-phone-forward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-hangup"></i> mdi mdi-phone-hangup
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-in-talk"></i> mdi
              mdi-phone-in-talk
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-incoming"></i> mdi
              mdi-phone-incoming
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-lock"></i> mdi mdi-phone-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-log"></i> mdi mdi-phone-log
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-minus"></i> mdi mdi-phone-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-missed"></i> mdi mdi-phone-missed
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-outgoing"></i> mdi
              mdi-phone-outgoing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-paused"></i> mdi mdi-phone-paused
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-plus"></i> mdi mdi-phone-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-return"></i> mdi mdi-phone-return
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-rotate-landscape"></i> mdi
              mdi-phone-rotate-landscape
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-rotate-portrait"></i> mdi
              mdi-phone-rotate-portrait
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-settings"></i> mdi
              mdi-phone-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-phone-voip"></i> mdi mdi-phone-voip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pi"></i> mdi mdi-pi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pi-box"></i> mdi mdi-pi-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-piano"></i> mdi mdi-piano
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pickaxe"></i> mdi mdi-pickaxe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pier"></i> mdi mdi-pier
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pier-crane"></i> mdi mdi-pier-crane
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pig"></i> mdi mdi-pig
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pill"></i> mdi mdi-pill
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pillar"></i> mdi mdi-pillar
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pin"></i> mdi mdi-pin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pin-off"></i> mdi mdi-pin-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pin-off-outline"></i> mdi
              mdi-pin-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pin-outline"></i> mdi mdi-pin-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pine-tree"></i> mdi mdi-pine-tree
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pine-tree-box"></i> mdi
              mdi-pine-tree-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pinterest"></i> mdi mdi-pinterest
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pinterest-box"></i> mdi
              mdi-pinterest-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pinwheel"></i> mdi mdi-pinwheel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pinwheel-outline"></i> mdi
              mdi-pinwheel-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pipe"></i> mdi mdi-pipe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pipe-disconnected"></i> mdi
              mdi-pipe-disconnected
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pipe-leak"></i> mdi mdi-pipe-leak
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pirate"></i> mdi mdi-pirate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pistol"></i> mdi mdi-pistol
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-piston"></i> mdi mdi-piston
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pizza"></i> mdi mdi-pizza
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-airplane"></i> mdi
              mdi-shield-airplane
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play"></i> mdi mdi-play
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play-box-outline"></i> mdi
              mdi-play-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play-circle"></i> mdi mdi-play-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play-circle-outline"></i> mdi
              mdi-play-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play-network"></i> mdi mdi-play-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play-pause"></i> mdi mdi-play-pause
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play-protected-content"></i> mdi
              mdi-play-protected-content
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-play-speed"></i> mdi mdi-play-speed
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playlist-check"></i> mdi
              mdi-playlist-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playlist-edit"></i> mdi
              mdi-playlist-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playlist-minus"></i> mdi
              mdi-playlist-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playlist-play"></i> mdi
              mdi-playlist-play
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playlist-plus"></i> mdi
              mdi-playlist-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playlist-remove"></i> mdi
              mdi-playlist-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-playstation"></i> mdi mdi-playstation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plex"></i> mdi mdi-plex
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus"></i> mdi mdi-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-box"></i> mdi mdi-plus-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-box-outline"></i> mdi
              mdi-plus-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-circle"></i> mdi mdi-plus-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-circle-multiple-outline"></i> mdi
              mdi-plus-circle-multiple-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-circle-outline"></i> mdi
              mdi-plus-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-minus"></i> mdi mdi-plus-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-minus-box"></i> mdi
              mdi-plus-minus-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-network"></i> mdi mdi-plus-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-one"></i> mdi mdi-plus-one
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-plus-outline"></i> mdi mdi-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pocket"></i> mdi mdi-pocket
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-podcast"></i> mdi mdi-podcast
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pokeball"></i> mdi mdi-pokeball
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pokemon-go"></i> mdi mdi-pokemon-go
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-poker-chip"></i> mdi mdi-poker-chip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-polaroid"></i> mdi mdi-polaroid
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-poll"></i> mdi mdi-poll
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-poll-box"></i> mdi mdi-poll-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-polymer"></i> mdi mdi-polymer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pool"></i> mdi mdi-pool
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-popcorn"></i> mdi mdi-popcorn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pot"></i> mdi mdi-pot
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pot-mix"></i> mdi mdi-pot-mix
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pound"></i> mdi mdi-pound
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pound-box"></i> mdi mdi-pound-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power"></i> mdi mdi-power
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-cycle"></i> mdi mdi-power-cycle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-off"></i> mdi mdi-power-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-on"></i> mdi mdi-power-on
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-plug"></i> mdi mdi-power-plug
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-plug-off"></i> mdi
              mdi-power-plug-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-settings"></i> mdi
              mdi-power-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-sleep"></i> mdi mdi-power-sleep
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-socket"></i> mdi mdi-power-socket
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-socket-au"></i> mdi
              mdi-power-socket-au
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-socket-eu"></i> mdi
              mdi-power-socket-eu
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-socket-uk"></i> mdi
              mdi-power-socket-uk
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-socket-us"></i> mdi
              mdi-power-socket-us
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-power-standby"></i> mdi
              mdi-power-standby
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-powershell"></i> mdi mdi-powershell
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-prescription"></i> mdi mdi-prescription
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-presentation"></i> mdi mdi-presentation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-presentation-play"></i> mdi
              mdi-presentation-play
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-printer"></i> mdi mdi-printer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-printer-3d"></i> mdi mdi-printer-3d
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-printer-alert"></i> mdi
              mdi-printer-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-printer-settings"></i> mdi
              mdi-printer-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-printer-wireless"></i> mdi
              mdi-printer-wireless
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-priority-high"></i> mdi
              mdi-priority-high
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-priority-low"></i> mdi mdi-priority-low
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-professional-hexagon"></i> mdi
              mdi-professional-hexagon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-progress-check"></i> mdi
              mdi-progress-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-progress-clock"></i> mdi
              mdi-progress-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-progress-download"></i> mdi
              mdi-progress-download
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-progress-upload"></i> mdi
              mdi-progress-upload
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-projector"></i> mdi mdi-projector
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-projector-screen"></i> mdi
              mdi-projector-screen
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-publish"></i> mdi mdi-publish
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-pulse"></i> mdi mdi-pulse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-puzzle"></i> mdi mdi-puzzle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-puzzle-outline"></i> mdi
              mdi-puzzle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-qi"></i> mdi mdi-qi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-qqchat"></i> mdi mdi-qqchat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-qrcode"></i> mdi mdi-qrcode
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-qrcode-edit"></i> mdi mdi-qrcode-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-qrcode-scan"></i> mdi mdi-qrcode-scan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-quadcopter"></i> mdi mdi-quadcopter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-quality-high"></i> mdi mdi-quality-high
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-quality-low"></i> mdi mdi-quality-low
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-quality-medium"></i> mdi
              mdi-quality-medium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-quicktime"></i> mdi mdi-quicktime
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rabbit"></i> mdi mdi-rabbit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radar"></i> mdi mdi-radar
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radiator"></i> mdi mdi-radiator
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radiator-disabled"></i> mdi
              mdi-radiator-disabled
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radiator-off"></i> mdi mdi-radiator-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radio"></i> mdi mdi-radio
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radio-handheld"></i> mdi
              mdi-radio-handheld
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radio-tower"></i> mdi mdi-radio-tower
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radioactive"></i> mdi mdi-radioactive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radiobox-blank"></i> mdi
              mdi-radiobox-blank
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-radiobox-marked"></i> mdi
              mdi-radiobox-marked
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-raspberrypi"></i> mdi mdi-raspberrypi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ray-end"></i> mdi mdi-ray-end
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ray-end-arrow"></i> mdi
              mdi-ray-end-arrow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ray-start"></i> mdi mdi-ray-start
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ray-start-arrow"></i> mdi
              mdi-ray-start-arrow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ray-start-end"></i> mdi
              mdi-ray-start-end
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ray-vertex"></i> mdi mdi-ray-vertex
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-react"></i> mdi mdi-react
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-read"></i> mdi mdi-read
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-receipt"></i> mdi mdi-receipt
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-record"></i> mdi mdi-record
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-record-player"></i> mdi
              mdi-record-player
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-record-rec"></i> mdi mdi-record-rec
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-recycle"></i> mdi mdi-recycle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reddit"></i> mdi mdi-reddit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-redo"></i> mdi mdi-redo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-redo-variant"></i> mdi mdi-redo-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reflect-horizontal"></i> mdi
              mdi-reflect-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reflect-vertical"></i> mdi
              mdi-reflect-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-refresh"></i> mdi mdi-refresh
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-regex"></i> mdi mdi-regex
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-registered-trademark"></i> mdi
              mdi-registered-trademark
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-relative-scale"></i> mdi
              mdi-relative-scale
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reload"></i> mdi mdi-reload
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reminder"></i> mdi mdi-reminder
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-remote"></i> mdi mdi-remote
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-remote-desktop"></i> mdi
              mdi-remote-desktop
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rename-box"></i> mdi mdi-rename-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reorder-horizontal"></i> mdi
              mdi-reorder-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reorder-vertical"></i> mdi
              mdi-reorder-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-repeat"></i> mdi mdi-repeat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-repeat-off"></i> mdi mdi-repeat-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-repeat-once"></i> mdi mdi-repeat-once
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-replay"></i> mdi mdi-replay
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reply"></i> mdi mdi-reply
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reply-all"></i> mdi mdi-reply-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-reproduction"></i> mdi mdi-reproduction
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-resistor"></i> mdi mdi-resistor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-resistor-nodes"></i> mdi
              mdi-resistor-nodes
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-resize"></i> mdi mdi-resize
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-resize-bottom-right"></i> mdi
              mdi-resize-bottom-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-responsive"></i> mdi mdi-responsive
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-restart"></i> mdi mdi-restart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-restore"></i> mdi mdi-restore
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-restore-clock"></i> mdi
              mdi-restore-clock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rewind"></i> mdi mdi-rewind
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rewind-outline"></i> mdi
              mdi-rewind-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rhombus"></i> mdi mdi-rhombus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rhombus-medium"></i> mdi
              mdi-rhombus-medium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rhombus-outline"></i> mdi
              mdi-rhombus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rhombus-split"></i> mdi
              mdi-rhombus-split
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ribbon"></i> mdi mdi-ribbon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rice"></i> mdi mdi-rice
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ring"></i> mdi mdi-ring
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-road"></i> mdi mdi-road
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-road-variant"></i> mdi mdi-road-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-robot"></i> mdi mdi-robot
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-robot-industrial"></i> mdi
              mdi-robot-industrial
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-robot-vacuum"></i> mdi mdi-robot-vacuum
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-robot-vacuum-variant"></i> mdi
              mdi-robot-vacuum-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rocket"></i> mdi mdi-rocket
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-room-service"></i> mdi mdi-room-service
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rotate-3d"></i> mdi mdi-rotate-3d
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rotate-left"></i> mdi mdi-rotate-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rotate-left-variant"></i> mdi
              mdi-rotate-left-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rotate-right"></i> mdi mdi-rotate-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rotate-right-variant"></i> mdi
              mdi-rotate-right-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rounded-corner"></i> mdi
              mdi-rounded-corner
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-router-wireless"></i> mdi
              mdi-router-wireless
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-router-wireless-settings"></i> mdi
              mdi-router-wireless-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-routes"></i> mdi mdi-routes
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rowing"></i> mdi mdi-rowing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rss"></i> mdi mdi-rss
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-rss-box"></i> mdi mdi-rss-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ruler"></i> mdi mdi-ruler
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-run"></i> mdi mdi-run
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-run-fast"></i> mdi mdi-run-fast
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-safe"></i> mdi mdi-safe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sale"></i> mdi mdi-sale
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-salesforce"></i> mdi mdi-salesforce
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sass"></i> mdi mdi-sass
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-satellite"></i> mdi mdi-satellite
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-satellite-uplink"></i> mdi
              mdi-satellite-uplink
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-satellite-variant"></i> mdi
              mdi-satellite-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sausage"></i> mdi mdi-sausage
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-saxophone"></i> mdi mdi-saxophone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-scale"></i> mdi mdi-scale
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-scale-balance"></i> mdi
              mdi-scale-balance
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-scale-bathroom"></i> mdi
              mdi-scale-bathroom
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-scanner"></i> mdi mdi-scanner
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-scanner-off"></i> mdi mdi-scanner-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-school"></i> mdi mdi-school
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-scissors-cutting"></i> mdi
              mdi-scissors-cutting
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-screen-rotation"></i> mdi
              mdi-screen-rotation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-screen-rotation-lock"></i> mdi
              mdi-screen-rotation-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-screwdriver"></i> mdi mdi-screwdriver
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-script"></i> mdi mdi-script
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sd"></i> mdi mdi-sd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seal"></i> mdi mdi-seal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-search-web"></i> mdi mdi-search-web
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-flat"></i> mdi mdi-seat-flat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-flat-angled"></i> mdi
              mdi-seat-flat-angled
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-individual-suite"></i> mdi
              mdi-seat-individual-suite
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-legroom-extra"></i> mdi
              mdi-seat-legroom-extra
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-legroom-normal"></i> mdi
              mdi-seat-legroom-normal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-legroom-reduced"></i> mdi
              mdi-seat-legroom-reduced
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-recline-extra"></i> mdi
              mdi-seat-recline-extra
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-seat-recline-normal"></i> mdi
              mdi-seat-recline-normal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-security"></i> mdi mdi-security
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-account"></i> mdi
              mdi-shield-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-account-outline"></i> mdi
              mdi-shield-account-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-home"></i> mdi mdi-shield-home
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-lock"></i> mdi mdi-shield-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-off"></i> mdi mdi-shield-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-select"></i> mdi mdi-select
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-select-all"></i> mdi mdi-select-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-select-compare"></i> mdi
              mdi-select-compare
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-select-drag"></i> mdi mdi-select-drag
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-select-inverse"></i> mdi
              mdi-select-inverse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-select-off"></i> mdi mdi-select-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-selection"></i> mdi mdi-selection
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-selection-drag"></i> mdi
              mdi-selection-drag
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-selection-off"></i> mdi
              mdi-selection-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-send"></i> mdi mdi-send
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-send-lock"></i> mdi mdi-send-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-serial-port"></i> mdi mdi-serial-port
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-server"></i> mdi mdi-server
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-server-minus"></i> mdi mdi-server-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-server-off"></i> mdi mdi-server-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-server-plus"></i> mdi mdi-server-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-server-remove"></i> mdi
              mdi-server-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-server-security"></i> mdi
              mdi-server-security
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-all"></i> mdi mdi-set-all
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-center"></i> mdi mdi-set-center
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-center-right"></i> mdi
              mdi-set-center-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-left"></i> mdi mdi-set-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-left-center"></i> mdi
              mdi-set-left-center
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-left-right"></i> mdi
              mdi-set-left-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-none"></i> mdi mdi-set-none
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-right"></i> mdi mdi-set-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-set-top-box"></i> mdi mdi-set-top-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-settings"></i> mdi mdi-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-settings-box"></i> mdi mdi-settings-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-settings-helper"></i> mdi
              mdi-settings-helper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-settings-outline"></i> mdi
              mdi-settings-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shape"></i> mdi mdi-shape
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shape-circle-plus"></i> mdi
              mdi-shape-circle-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shape-outline"></i> mdi
              mdi-shape-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shape-plus"></i> mdi mdi-shape-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shape-polygon-plus"></i> mdi
              mdi-shape-polygon-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shape-rectangle-plus"></i> mdi
              mdi-shape-rectangle-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shape-square-plus"></i> mdi
              mdi-shape-square-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-share"></i> mdi mdi-share
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-share-outline"></i> mdi
              mdi-share-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-share-variant"></i> mdi
              mdi-share-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield"></i> mdi mdi-shield
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-half-full"></i> mdi
              mdi-shield-half-full
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-outline"></i> mdi
              mdi-shield-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-plus"></i> mdi mdi-shield-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-plus-outline"></i> mdi
              mdi-shield-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-remove-outline"></i> mdi
              mdi-shield-remove-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ship-wheel"></i> mdi mdi-ship-wheel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shoe-formal"></i> mdi mdi-shoe-formal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shoe-heel"></i> mdi mdi-shoe-heel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shopify"></i> mdi mdi-shopify
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shopping"></i> mdi mdi-shopping
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shopping-music"></i> mdi
              mdi-shopping-music
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shovel"></i> mdi mdi-shovel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shovel-off"></i> mdi mdi-shovel-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shower"></i> mdi mdi-shower
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shower-head"></i> mdi mdi-shower-head
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shredder"></i> mdi mdi-shredder
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shuffle"></i> mdi mdi-shuffle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shuffle-disabled"></i> mdi
              mdi-shuffle-disabled
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shuffle-variant"></i> mdi
              mdi-shuffle-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sigma"></i> mdi mdi-sigma
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sigma-lower"></i> mdi mdi-sigma-lower
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sign-caution"></i> mdi mdi-sign-caution
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sign-direction"></i> mdi
              mdi-sign-direction
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sign-text"></i> mdi mdi-sign-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal"></i> mdi mdi-signal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-2g"></i> mdi mdi-signal-2g
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-3g"></i> mdi mdi-signal-3g
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-4g"></i> mdi mdi-signal-4g
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-5g"></i> mdi mdi-signal-5g
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-cellular-1"></i> mdi
              mdi-signal-cellular-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-cellular-2"></i> mdi
              mdi-signal-cellular-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-cellular-3"></i> mdi
              mdi-signal-cellular-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-cellular-outline"></i> mdi
              mdi-signal-cellular-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-hspa"></i> mdi mdi-signal-hspa
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-hspa-plus"></i> mdi
              mdi-signal-hspa-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-off"></i> mdi mdi-signal-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-signal-variant"></i> mdi
              mdi-signal-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-silo"></i> mdi mdi-silo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-silverware"></i> mdi mdi-silverware
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-silverware-fork"></i> mdi
              mdi-silverware-fork
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-silverware-fork-knife"></i> mdi
              mdi-silverware-fork-knife
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-silverware-spoon"></i> mdi
              mdi-silverware-spoon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-silverware-variant"></i> mdi
              mdi-silverware-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sim"></i> mdi mdi-sim
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sim-alert"></i> mdi mdi-sim-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sim-off"></i> mdi mdi-sim-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sina-weibo"></i> mdi mdi-sina-weibo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sitemap"></i> mdi mdi-sitemap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skip-backward"></i> mdi
              mdi-skip-backward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skip-forward"></i> mdi mdi-skip-forward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skip-next"></i> mdi mdi-skip-next
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skip-next-circle"></i> mdi
              mdi-skip-next-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skip-next-circle-outline"></i> mdi
              mdi-skip-next-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skip-previous"></i> mdi
              mdi-skip-previous
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skip-previous-circle"></i> mdi
              mdi-skip-previous-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skip-previous-circle-outline"></i> mdi
              mdi-skip-previous-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skull"></i> mdi mdi-skull
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skype"></i> mdi mdi-skype
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-skype-business"></i> mdi
              mdi-skype-business
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-slack"></i> mdi mdi-slack
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-slackware"></i> mdi mdi-slackware
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sleep"></i> mdi mdi-sleep
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sleep-off"></i> mdi mdi-sleep-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-smog"></i> mdi mdi-smog
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-snapchat"></i> mdi mdi-snapchat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-snowflake"></i> mdi mdi-snowflake
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-snowman"></i> mdi mdi-snowman
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-soccer"></i> mdi mdi-soccer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-soccer-field"></i> mdi mdi-soccer-field
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sofa"></i> mdi mdi-sofa
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-solar-power"></i> mdi mdi-solar-power
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-solid"></i> mdi mdi-solid
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sort"></i> mdi mdi-sort
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sort-alphabetical"></i> mdi
              mdi-sort-alphabetical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sort-ascending"></i> mdi
              mdi-sort-ascending
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sort-descending"></i> mdi
              mdi-sort-descending
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sort-numeric"></i> mdi mdi-sort-numeric
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sort-variant"></i> mdi mdi-sort-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-soundcloud"></i> mdi mdi-soundcloud
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-branch"></i> mdi
              mdi-source-branch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-commit"></i> mdi
              mdi-source-commit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-commit-end"></i> mdi
              mdi-source-commit-end
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-commit-end-local"></i> mdi
              mdi-source-commit-end-local
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-commit-local"></i> mdi
              mdi-source-commit-local
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-commit-next-local"></i> mdi
              mdi-source-commit-next-local
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-commit-start"></i> mdi
              mdi-source-commit-start
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-commit-start-next-local"></i> mdi
              mdi-source-commit-start-next-local
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-fork"></i> mdi mdi-source-fork
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-merge"></i> mdi mdi-source-merge
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-source-pull"></i> mdi mdi-source-pull
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-soy-sauce"></i> mdi mdi-soy-sauce
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-speaker"></i> mdi mdi-speaker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-speaker-bluetooth"></i> mdi
              mdi-speaker-bluetooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-speaker-off"></i> mdi mdi-speaker-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-speaker-wireless"></i> mdi
              mdi-speaker-wireless
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-speedometer"></i> mdi mdi-speedometer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-spellcheck"></i> mdi mdi-spellcheck
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-spotify"></i> mdi mdi-spotify
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-spotlight"></i> mdi mdi-spotlight
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-spotlight-beam"></i> mdi
              mdi-spotlight-beam
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-spray"></i> mdi mdi-spray
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-spray-bottle"></i> mdi mdi-spray-bottle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square"></i> mdi mdi-square
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-edit-outline"></i> mdi
              mdi-square-edit-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-inc"></i> mdi mdi-square-inc
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-inc-cash"></i> mdi
              mdi-square-inc-cash
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-medium"></i> mdi
              mdi-square-medium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-medium-outline"></i> mdi
              mdi-square-medium-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-outline"></i> mdi
              mdi-square-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-root"></i> mdi mdi-square-root
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-root-box"></i> mdi
              mdi-square-root-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-square-small"></i> mdi mdi-square-small
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-squeegee"></i> mdi mdi-squeegee
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ssh"></i> mdi mdi-ssh
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stack-exchange"></i> mdi
              mdi-stack-exchange
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stack-overflow"></i> mdi
              mdi-stack-overflow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stadium"></i> mdi mdi-stadium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stairs"></i> mdi mdi-stairs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-standard-definition"></i> mdi
              mdi-standard-definition
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star"></i> mdi mdi-star
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-box"></i> mdi mdi-star-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-box-outline"></i> mdi
              mdi-star-box-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-circle"></i> mdi mdi-star-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-circle-outline"></i> mdi
              mdi-star-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-face"></i> mdi mdi-star-face
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-four-points"></i> mdi
              mdi-star-four-points
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-four-points-outline"></i> mdi
              mdi-star-four-points-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-half"></i> mdi mdi-star-half
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-off"></i> mdi mdi-star-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-outline"></i> mdi mdi-star-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-three-points"></i> mdi
              mdi-star-three-points
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-star-three-points-outline"></i> mdi
              mdi-star-three-points-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-steam"></i> mdi mdi-steam
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-steam-box"></i> mdi mdi-steam-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-steering"></i> mdi mdi-steering
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-steering-off"></i> mdi mdi-steering-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-step-backward"></i> mdi
              mdi-step-backward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-step-backward-2"></i> mdi
              mdi-step-backward-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-step-forward"></i> mdi mdi-step-forward
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-step-forward-2"></i> mdi
              mdi-step-forward-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stethoscope"></i> mdi mdi-stethoscope
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sticker"></i> mdi mdi-sticker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sticker-emoji"></i> mdi
              mdi-sticker-emoji
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stocking"></i> mdi mdi-stocking
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stop"></i> mdi mdi-stop
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stop-circle"></i> mdi mdi-stop-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stop-circle-outline"></i> mdi
              mdi-stop-circle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-store"></i> mdi mdi-store
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-store-24-hour"></i> mdi
              mdi-store-24-hour
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-stove"></i> mdi mdi-stove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-strava"></i> mdi mdi-strava
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-subdirectory-arrow-left"></i> mdi
              mdi-subdirectory-arrow-left
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-subdirectory-arrow-right"></i> mdi
              mdi-subdirectory-arrow-right
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-subtitles"></i> mdi mdi-subtitles
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-subtitles-outline"></i> mdi
              mdi-subtitles-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-subway"></i> mdi mdi-subway
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-subway-variant"></i> mdi
              mdi-subway-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-summit"></i> mdi mdi-summit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sunglasses"></i> mdi mdi-sunglasses
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-surround-sound"></i> mdi
              mdi-surround-sound
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-surround-sound-2-0"></i> mdi
              mdi-surround-sound-2-0
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-surround-sound-3-1"></i> mdi
              mdi-surround-sound-3-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-surround-sound-5-1"></i> mdi
              mdi-surround-sound-5-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-surround-sound-7-1"></i> mdi
              mdi-surround-sound-7-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-svg"></i> mdi mdi-svg
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-swap-horizontal"></i> mdi
              mdi-swap-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-swap-horizontal-variant"></i> mdi
              mdi-swap-horizontal-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-swap-vertical"></i> mdi
              mdi-swap-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-swap-vertical-variant"></i> mdi
              mdi-swap-vertical-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-swim"></i> mdi mdi-swim
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-switch"></i> mdi mdi-switch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sword"></i> mdi mdi-sword
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sword-cross"></i> mdi mdi-sword-cross
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-symfony"></i> mdi mdi-symfony
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sync"></i> mdi mdi-sync
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sync-alert"></i> mdi mdi-sync-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-sync-off"></i> mdi mdi-sync-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tab"></i> mdi mdi-tab
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tab-minus"></i> mdi mdi-tab-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tab-plus"></i> mdi mdi-tab-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tab-remove"></i> mdi mdi-tab-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tab-unselected"></i> mdi
              mdi-tab-unselected
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table"></i> mdi mdi-table
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-border"></i> mdi mdi-table-border
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-column"></i> mdi mdi-table-column
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-column-plus-after"></i> mdi
              mdi-table-column-plus-after
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-column-plus-before"></i> mdi
              mdi-table-column-plus-before
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-column-remove"></i> mdi
              mdi-table-column-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-column-width"></i> mdi
              mdi-table-column-width
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-edit"></i> mdi mdi-table-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-large"></i> mdi mdi-table-large
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-merge-cells"></i> mdi
              mdi-table-merge-cells
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-of-contents"></i> mdi
              mdi-table-of-contents
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-plus"></i> mdi mdi-table-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-remove"></i> mdi mdi-table-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-row"></i> mdi mdi-table-row
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-row-height"></i> mdi
              mdi-table-row-height
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-row-plus-after"></i> mdi
              mdi-table-row-plus-after
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-row-plus-before"></i> mdi
              mdi-table-row-plus-before
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-row-remove"></i> mdi
              mdi-table-row-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-search"></i> mdi mdi-table-search
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-table-settings"></i> mdi
              mdi-table-settings
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tablet"></i> mdi mdi-tablet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tablet-android"></i> mdi
              mdi-tablet-android
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tablet-cellphone"></i> mdi
              mdi-tablet-cellphone
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tablet-ipad"></i> mdi mdi-tablet-ipad
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-taco"></i> mdi mdi-taco
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag"></i> mdi mdi-tag
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag-faces"></i> mdi mdi-tag-faces
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag-heart"></i> mdi mdi-tag-heart
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag-minus"></i> mdi mdi-tag-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag-multiple"></i> mdi mdi-tag-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag-outline"></i> mdi mdi-tag-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag-plus"></i> mdi mdi-tag-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag-remove"></i> mdi mdi-tag-remove
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tag-text-outline"></i> mdi
              mdi-tag-text-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tape-measure"></i> mdi mdi-tape-measure
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-target"></i> mdi mdi-target
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-target-variant"></i> mdi
              mdi-target-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-taxi"></i> mdi mdi-taxi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-teach"></i> mdi mdi-teach
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-teamviewer"></i> mdi mdi-teamviewer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-telegram"></i> mdi mdi-telegram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-telescope"></i> mdi mdi-telescope
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-television"></i> mdi mdi-television
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-television-box"></i> mdi
              mdi-television-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-television-classic"></i> mdi
              mdi-television-classic
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-television-classic-off"></i> mdi
              mdi-television-classic-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-television-guide"></i> mdi
              mdi-television-guide
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-television-off"></i> mdi
              mdi-television-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-temperature-celsius"></i> mdi
              mdi-temperature-celsius
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-temperature-fahrenheit"></i> mdi
              mdi-temperature-fahrenheit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-temperature-kelvin"></i> mdi
              mdi-temperature-kelvin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tennis"></i> mdi mdi-tennis
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tent"></i> mdi mdi-tent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-terrain"></i> mdi mdi-terrain
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-test-tube"></i> mdi mdi-test-tube
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-test-tube-empty"></i> mdi
              mdi-test-tube-empty
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-test-tube-off"></i> mdi
              mdi-test-tube-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-text"></i> mdi mdi-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-text-shadow"></i> mdi mdi-text-shadow
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-text-short"></i> mdi mdi-text-short
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-text-subject"></i> mdi mdi-text-subject
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-text-to-speech"></i> mdi
              mdi-text-to-speech
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-text-to-speech-off"></i> mdi
              mdi-text-to-speech-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-textbox"></i> mdi mdi-textbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-textbox-password"></i> mdi
              mdi-textbox-password
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-texture"></i> mdi mdi-texture
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-theater"></i> mdi mdi-theater
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-theme-light-dark"></i> mdi
              mdi-theme-light-dark
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thermometer"></i> mdi mdi-thermometer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thermometer-lines"></i> mdi
              mdi-thermometer-lines
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thermostat"></i> mdi mdi-thermostat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thermostat-box"></i> mdi
              mdi-thermostat-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thought-bubble"></i> mdi
              mdi-thought-bubble
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thought-bubble-outline"></i> mdi
              mdi-thought-bubble-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thumb-down"></i> mdi mdi-thumb-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thumb-down-outline"></i> mdi
              mdi-thumb-down-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thumb-up"></i> mdi mdi-thumb-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thumb-up-outline"></i> mdi
              mdi-thumb-up-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-thumbs-up-down"></i> mdi
              mdi-thumbs-up-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ticket"></i> mdi mdi-ticket
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ticket-account"></i> mdi
              mdi-ticket-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ticket-confirmation"></i> mdi
              mdi-ticket-confirmation
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ticket-outline"></i> mdi
              mdi-ticket-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ticket-percent"></i> mdi
              mdi-ticket-percent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tie"></i> mdi mdi-tie
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tilde"></i> mdi mdi-tilde
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timelapse"></i> mdi mdi-timelapse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timer"></i> mdi mdi-timer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timer-10"></i> mdi mdi-timer-10
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timer-3"></i> mdi mdi-timer-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timer-off"></i> mdi mdi-timer-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timer-sand"></i> mdi mdi-timer-sand
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timer-sand-empty"></i> mdi
              mdi-timer-sand-empty
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timer-sand-full"></i> mdi
              mdi-timer-sand-full
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-timetable"></i> mdi mdi-timetable
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-toggle-switch"></i> mdi
              mdi-toggle-switch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-toggle-switch-off"></i> mdi
              mdi-toggle-switch-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-toggle-switch-off-outline"></i> mdi
              mdi-toggle-switch-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-toggle-switch-outline"></i> mdi
              mdi-toggle-switch-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-toilet"></i> mdi mdi-toilet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-toolbox"></i> mdi mdi-toolbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-toolbox-outline"></i> mdi
              mdi-toolbox-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooltip"></i> mdi mdi-tooltip
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooltip-edit"></i> mdi mdi-tooltip-edit
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooltip-image"></i> mdi
              mdi-tooltip-image
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooltip-outline"></i> mdi
              mdi-tooltip-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooltip-plus-outline"></i> mdi
              mdi-tooltip-plus-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooltip-text"></i> mdi mdi-tooltip-text
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooth"></i> mdi mdi-tooth
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tooth-outline"></i> mdi
              mdi-tooth-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tor"></i> mdi mdi-tor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tournament"></i> mdi mdi-tournament
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tower-beach"></i> mdi mdi-tower-beach
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tower-fire"></i> mdi mdi-tower-fire
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-towing"></i> mdi mdi-towing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-track-light"></i> mdi mdi-track-light
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trackpad"></i> mdi mdi-trackpad
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trackpad-lock"></i> mdi
              mdi-trackpad-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tractor"></i> mdi mdi-tractor
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trademark"></i> mdi mdi-trademark
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-traffic-light"></i> mdi
              mdi-traffic-light
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-train"></i> mdi mdi-train
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-train-variant"></i> mdi
              mdi-train-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tram"></i> mdi mdi-tram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transcribe"></i> mdi mdi-transcribe
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transcribe-close"></i> mdi
              mdi-transcribe-close
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transfer"></i> mdi mdi-transfer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transit-transfer"></i> mdi
              mdi-transit-transfer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transition"></i> mdi mdi-transition
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-transition-masked"></i> mdi
              mdi-transition-masked
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-translate"></i> mdi mdi-translate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trash-can"></i> mdi mdi-trash-can
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trash-can-outline"></i> mdi
              mdi-trash-can-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-treasure-chest"></i> mdi
              mdi-treasure-chest
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tree"></i> mdi mdi-tree
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trello"></i> mdi mdi-trello
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trending-down"></i> mdi
              mdi-trending-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trending-neutral"></i> mdi
              mdi-trending-neutral
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trending-up"></i> mdi mdi-trending-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-triangle"></i> mdi mdi-triangle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-triangle-outline"></i> mdi
              mdi-triangle-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trophy"></i> mdi mdi-trophy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trophy-award"></i> mdi mdi-trophy-award
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trophy-outline"></i> mdi
              mdi-trophy-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trophy-variant"></i> mdi
              mdi-trophy-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-trophy-variant-outline"></i> mdi
              mdi-trophy-variant-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-truck"></i> mdi mdi-truck
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-truck-delivery"></i> mdi
              mdi-truck-delivery
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-truck-fast"></i> mdi mdi-truck-fast
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-truck-trailer"></i> mdi
              mdi-truck-trailer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tshirt-crew"></i> mdi mdi-tshirt-crew
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tshirt-crew-outline"></i> mdi
              mdi-tshirt-crew-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tshirt-v"></i> mdi mdi-tshirt-v
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tshirt-v-outline"></i> mdi
              mdi-tshirt-v-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tumble-dryer"></i> mdi mdi-tumble-dryer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tumblr"></i> mdi mdi-tumblr
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tumblr-box"></i> mdi mdi-tumblr-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tumblr-reblog"></i> mdi
              mdi-tumblr-reblog
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tune"></i> mdi mdi-tune
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-tune-vertical"></i> mdi
              mdi-tune-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-twitch"></i> mdi mdi-twitch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-twitter"></i> mdi mdi-twitter
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-twitter-box"></i> mdi mdi-twitter-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-twitter-circle"></i> mdi
              mdi-twitter-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-twitter-retweet"></i> mdi
              mdi-twitter-retweet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-two-factor-authentication"></i> mdi
              mdi-two-factor-authentication
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-uber"></i> mdi mdi-uber
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ubuntu"></i> mdi mdi-ubuntu
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ultra-high-definition"></i> mdi
              mdi-ultra-high-definition
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-umbraco"></i> mdi mdi-umbraco
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-umbrella"></i> mdi mdi-umbrella
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-umbrella-closed"></i> mdi
              mdi-umbrella-closed
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-umbrella-outline"></i> mdi
              mdi-umbrella-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-undo"></i> mdi mdi-undo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-undo-variant"></i> mdi mdi-undo-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-unfold-less-horizontal"></i> mdi
              mdi-unfold-less-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-unfold-less-vertical"></i> mdi
              mdi-unfold-less-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-unfold-more-horizontal"></i> mdi
              mdi-unfold-more-horizontal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-unfold-more-vertical"></i> mdi
              mdi-unfold-more-vertical
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-ungroup"></i> mdi mdi-ungroup
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-unity"></i> mdi mdi-unity
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-unreal"></i> mdi mdi-unreal
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-untappd"></i> mdi mdi-untappd
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-update"></i> mdi mdi-update
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-upload"></i> mdi mdi-upload
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-upload-multiple"></i> mdi
              mdi-upload-multiple
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-upload-network"></i> mdi
              mdi-upload-network
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-usb"></i> mdi mdi-usb
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-van-passenger"></i> mdi
              mdi-van-passenger
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-van-utility"></i> mdi mdi-van-utility
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vanish"></i> mdi mdi-vanish
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-variable"></i> mdi mdi-variable
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-arrange-above"></i> mdi
              mdi-vector-arrange-above
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-arrange-below"></i> mdi
              mdi-vector-arrange-below
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-bezier"></i> mdi
              mdi-vector-bezier
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-circle"></i> mdi
              mdi-vector-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-circle-variant"></i> mdi
              mdi-vector-circle-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-combine"></i> mdi
              mdi-vector-combine
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-curve"></i> mdi mdi-vector-curve
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-difference"></i> mdi
              mdi-vector-difference
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-difference-ab"></i> mdi
              mdi-vector-difference-ab
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-difference-ba"></i> mdi
              mdi-vector-difference-ba
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-ellipse"></i> mdi
              mdi-vector-ellipse
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-intersection"></i> mdi
              mdi-vector-intersection
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-line"></i> mdi mdi-vector-line
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-point"></i> mdi mdi-vector-point
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-polygon"></i> mdi
              mdi-vector-polygon
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-polyline"></i> mdi
              mdi-vector-polyline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-radius"></i> mdi
              mdi-vector-radius
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-rectangle"></i> mdi
              mdi-vector-rectangle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-selection"></i> mdi
              mdi-vector-selection
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-square"></i> mdi
              mdi-vector-square
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-triangle"></i> mdi
              mdi-vector-triangle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vector-union"></i> mdi mdi-vector-union
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-venmo"></i> mdi mdi-venmo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-shield-check"></i> mdi mdi-shield-check
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vhs"></i> mdi mdi-vhs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vibrate"></i> mdi mdi-vibrate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video"></i> mdi mdi-video
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-3d"></i> mdi mdi-video-3d
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-4k-box"></i> mdi mdi-video-4k-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-account"></i> mdi
              mdi-video-account
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-image"></i> mdi mdi-video-image
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-input-antenna"></i> mdi
              mdi-video-input-antenna
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-input-component"></i> mdi
              mdi-video-input-component
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-input-hdmi"></i> mdi
              mdi-video-input-hdmi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-input-svideo"></i> mdi
              mdi-video-input-svideo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-minus"></i> mdi mdi-video-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-off"></i> mdi mdi-video-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-plus"></i> mdi mdi-video-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-stabilization"></i> mdi
              mdi-video-stabilization
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-switch"></i> mdi mdi-video-switch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-video-vintage"></i> mdi
              mdi-video-vintage
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-agenda"></i> mdi mdi-view-agenda
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-array"></i> mdi mdi-view-array
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-carousel"></i> mdi
              mdi-view-carousel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-column"></i> mdi mdi-view-column
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-dashboard"></i> mdi
              mdi-view-dashboard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-dashboard-outline"></i> mdi
              mdi-view-dashboard-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-dashboard-variant"></i> mdi
              mdi-view-dashboard-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-day"></i> mdi mdi-view-day
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-grid"></i> mdi mdi-view-grid
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-headline"></i> mdi
              mdi-view-headline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-list"></i> mdi mdi-view-list
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-module"></i> mdi mdi-view-module
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-parallel"></i> mdi
              mdi-view-parallel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-quilt"></i> mdi mdi-view-quilt
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-sequential"></i> mdi
              mdi-view-sequential
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-stream"></i> mdi mdi-view-stream
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-view-week"></i> mdi mdi-view-week
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vimeo"></i> mdi mdi-vimeo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-violin"></i> mdi mdi-violin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-virtual-reality"></i> mdi
              mdi-virtual-reality
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-visual-studio"></i> mdi
              mdi-visual-studio
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-visual-studio-code"></i> mdi
              mdi-visual-studio-code
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vk"></i> mdi mdi-vk
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vk-box"></i> mdi mdi-vk-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vk-circle"></i> mdi mdi-vk-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vlc"></i> mdi mdi-vlc
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-voice"></i> mdi mdi-voice
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-voicemail"></i> mdi mdi-voicemail
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-volleyball"></i> mdi mdi-volleyball
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-volume-high"></i> mdi mdi-volume-high
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-volume-low"></i> mdi mdi-volume-low
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-volume-medium"></i> mdi
              mdi-volume-medium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-volume-minus"></i> mdi mdi-volume-minus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-volume-mute"></i> mdi mdi-volume-mute
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-volume-off"></i> mdi mdi-volume-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-volume-plus"></i> mdi mdi-volume-plus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vote"></i> mdi mdi-vote
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vote-outline"></i> mdi mdi-vote-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vpn"></i> mdi mdi-vpn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-vuejs"></i> mdi mdi-vuejs
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-walk"></i> mdi mdi-walk
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wall"></i> mdi mdi-wall
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wall-sconce"></i> mdi mdi-wall-sconce
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wall-sconce-flat"></i> mdi
              mdi-wall-sconce-flat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wall-sconce-variant"></i> mdi
              mdi-wall-sconce-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wallet"></i> mdi mdi-wallet
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wallet-giftcard"></i> mdi
              mdi-wallet-giftcard
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wallet-membership"></i> mdi
              mdi-wallet-membership
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wallet-travel"></i> mdi
              mdi-wallet-travel
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wan"></i> mdi mdi-wan
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-washing-machine"></i> mdi
              mdi-washing-machine
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watch"></i> mdi mdi-watch
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watch-export"></i> mdi mdi-watch-export
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watch-export-variant"></i> mdi
              mdi-watch-export-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watch-import"></i> mdi mdi-watch-import
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watch-import-variant"></i> mdi
              mdi-watch-import-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watch-variant"></i> mdi
              mdi-watch-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watch-vibrate"></i> mdi
              mdi-watch-vibrate
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-water"></i> mdi mdi-water
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-water-off"></i> mdi mdi-water-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-water-percent"></i> mdi
              mdi-water-percent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-water-pump"></i> mdi mdi-water-pump
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-watermark"></i> mdi mdi-watermark
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-waves"></i> mdi mdi-waves
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-cloudy"></i> mdi
              mdi-weather-cloudy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-fog"></i> mdi mdi-weather-fog
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-hail"></i> mdi mdi-weather-hail
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-hurricane"></i> mdi
              mdi-weather-hurricane
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-lightning"></i> mdi
              mdi-weather-lightning
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-lightning-rainy"></i> mdi
              mdi-weather-lightning-rainy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-night"></i> mdi
              mdi-weather-night
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-partlycloudy"></i> mdi
              mdi-weather-partlycloudy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-pouring"></i> mdi
              mdi-weather-pouring
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-rainy"></i> mdi
              mdi-weather-rainy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-snowy"></i> mdi
              mdi-weather-snowy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-snowy-rainy"></i> mdi
              mdi-weather-snowy-rainy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-sunny"></i> mdi
              mdi-weather-sunny
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-sunset"></i> mdi
              mdi-weather-sunset
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-sunset-down"></i> mdi
              mdi-weather-sunset-down
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-sunset-up"></i> mdi
              mdi-weather-sunset-up
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-windy"></i> mdi
              mdi-weather-windy
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weather-windy-variant"></i> mdi
              mdi-weather-windy-variant
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-web"></i> mdi mdi-web
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-webcam"></i> mdi mdi-webcam
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-webhook"></i> mdi mdi-webhook
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-webpack"></i> mdi mdi-webpack
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wechat"></i> mdi mdi-wechat
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weight"></i> mdi mdi-weight
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weight-kilogram"></i> mdi
              mdi-weight-kilogram
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-weight-pound"></i> mdi mdi-weight-pound
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-whatsapp"></i> mdi mdi-whatsapp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wheelchair-accessibility"></i> mdi
              mdi-wheelchair-accessibility
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-whistle"></i> mdi mdi-whistle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-white-balance-auto"></i> mdi
              mdi-white-balance-auto
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-white-balance-incandescent"></i> mdi
              mdi-white-balance-incandescent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-white-balance-iridescent"></i> mdi
              mdi-white-balance-iridescent
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-white-balance-sunny"></i> mdi
              mdi-white-balance-sunny
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-widgets"></i> mdi mdi-widgets
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi"></i> mdi mdi-wifi
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-off"></i> mdi mdi-wifi-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-1"></i> mdi
              mdi-wifi-strength-1
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-1-alert"></i> mdi
              mdi-wifi-strength-1-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-1-lock"></i> mdi
              mdi-wifi-strength-1-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-2"></i> mdi
              mdi-wifi-strength-2
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-2-alert"></i> mdi
              mdi-wifi-strength-2-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-2-lock"></i> mdi
              mdi-wifi-strength-2-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-3"></i> mdi
              mdi-wifi-strength-3
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-3-alert"></i> mdi
              mdi-wifi-strength-3-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-3-lock"></i> mdi
              mdi-wifi-strength-3-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-4"></i> mdi
              mdi-wifi-strength-4
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-4-alert"></i> mdi
              mdi-wifi-strength-4-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-4-lock"></i> mdi
              mdi-wifi-strength-4-lock
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-alert-outline"></i> mdi
              mdi-wifi-strength-alert-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-lock-outline"></i> mdi
              mdi-wifi-strength-lock-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-off"></i> mdi
              mdi-wifi-strength-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-off-outline"></i> mdi
              mdi-wifi-strength-off-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wifi-strength-outline"></i> mdi
              mdi-wifi-strength-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wii"></i> mdi mdi-wii
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wiiu"></i> mdi mdi-wiiu
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wikipedia"></i> mdi mdi-wikipedia
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-window-close"></i> mdi mdi-window-close
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-window-closed"></i> mdi
              mdi-window-closed
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-window-maximize"></i> mdi
              mdi-window-maximize
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-window-minimize"></i> mdi
              mdi-window-minimize
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-window-open"></i> mdi mdi-window-open
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-window-restore"></i> mdi
              mdi-window-restore
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-windows"></i> mdi mdi-windows
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-windows-classic"></i> mdi
              mdi-windows-classic
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wiper"></i> mdi mdi-wiper
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wordpress"></i> mdi mdi-wordpress
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-worker"></i> mdi mdi-worker
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wrap"></i> mdi mdi-wrap
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wrench"></i> mdi mdi-wrench
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-wunderlist"></i> mdi mdi-wunderlist
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xamarin"></i> mdi mdi-xamarin
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xamarin-outline"></i> mdi
              mdi-xamarin-outline
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xaml"></i> mdi mdi-xaml
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox"></i> mdi mdi-xbox
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller"></i> mdi
              mdi-xbox-controller
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller-battery-alert"></i> mdi
              mdi-xbox-controller-battery-alert
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller-battery-charging"></i>
              mdi mdi-xbox-controller-battery-charging
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller-battery-empty"></i> mdi
              mdi-xbox-controller-battery-empty
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller-battery-full"></i> mdi
              mdi-xbox-controller-battery-full
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller-battery-low"></i> mdi
              mdi-xbox-controller-battery-low
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller-battery-medium"></i> mdi
              mdi-xbox-controller-battery-medium
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller-battery-unknown"></i>
              mdi mdi-xbox-controller-battery-unknown
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xbox-controller-off"></i> mdi
              mdi-xbox-controller-off
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xda"></i> mdi mdi-xda
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xing"></i> mdi mdi-xing
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xing-box"></i> mdi mdi-xing-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xing-circle"></i> mdi mdi-xing-circle
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xml"></i> mdi mdi-xml
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-xmpp"></i> mdi mdi-xmpp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-yahoo"></i> mdi mdi-yahoo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-yammer"></i> mdi mdi-yammer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-yeast"></i> mdi mdi-yeast
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-yelp"></i> mdi mdi-yelp
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-yin-yang"></i> mdi mdi-yin-yang
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-youtube"></i> mdi mdi-youtube
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-youtube-creator-studio"></i> mdi
              mdi-youtube-creator-studio
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-youtube-gaming"></i> mdi
              mdi-youtube-gaming
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-youtube-tv"></i> mdi mdi-youtube-tv
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-z-wave"></i> mdi mdi-z-wave
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zend"></i> mdi mdi-zend
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zip-box"></i> mdi mdi-zip-box
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zip-disk"></i> mdi mdi-zip-disk
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-aquarius"></i> mdi
              mdi-zodiac-aquarius
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-aries"></i> mdi mdi-zodiac-aries
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-cancer"></i> mdi
              mdi-zodiac-cancer
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-capricorn"></i> mdi
              mdi-zodiac-capricorn
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-gemini"></i> mdi
              mdi-zodiac-gemini
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-leo"></i> mdi mdi-zodiac-leo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-libra"></i> mdi mdi-zodiac-libra
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-pisces"></i> mdi
              mdi-zodiac-pisces
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-sagittarius"></i> mdi
              mdi-zodiac-sagittarius
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-scorpio"></i> mdi
              mdi-zodiac-scorpio
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-taurus"></i> mdi
              mdi-zodiac-taurus
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-zodiac-virgo"></i> mdi mdi-zodiac-virgo
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <i class="mdi h5 mr-2 mdi-blank"></i> mdi mdi-blank
            </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>
